import { FormInput } from "../../components/form-input"
import Search from "../../../../assets/icons/search-alt.svg";
import { FormSelect } from "../../components/form-select";
import { cepValidator, cnpjValidator, mailValidator, requiredSelectValidator, sizeValidator } from "../../../../utils/validators";
import { useEffect, useState, useRef } from "react";
import { useFetch } from "../../../../hooks/useFetch";

import { Icon } from "../../../../components/icon";
import Arrow from "../../../../assets/icons/arrow-right.svg";
import Loading from "../../../../assets/icons/loading.svg"
import {
    cnpjMask,
    letraMask,
    cellMask,
    cepMask,
    numberMask,
    phoneMask,
} from "../../../../utils/masks";

export const DadosDaEmpresa = ({ nextStep }) => {
    const [searchParam, SetSearchParam] = useState("")

    const {data, isLoading, error} = useFetch(searchParam !="" && process.env.REACT_APP_API_URL+`Get_CompanyData?param=${searchParam}`)

    const [loadingSend, setLoadingSend] = useState(false)

    const formRef = useRef(null);   


    const [isValid, setIsValid] = useState(false);

    const [inputState, setInputState] = useState(
        {
            nomesocio: false,
            cnpj: false,
            nomeempresa: false,
            razaosocial: false,
            naturezalegal: false,
            cep: false,
            endereco: false,
            numero: false,
            complemento: false,
            bairro: false,
            uf: false,
            cidade: false,
            nomecompleto: false,
            cargo: false,
            celular: false,
            telefonecomercial: false,
            email: false,
            siteempresa: false,
            ramoatividade: false,// add
            cnae: false //add
        })

    const updateField = (field, state) => {
        setInputState(oldState => {
            const ccpy = { ...oldState }
            ccpy[field] = state;
            return { ...ccpy }
        })

    }





    function setInputs(model){
        //só para testes
        localStorage.setItem("idEmpresa",model.id_empresa)

        formRef.current.nomesocio.value = model.nm_socio
        formRef.current.cnpj.value = cnpjMask(model.cd_cnpj)
        formRef.current.nomeempresa.value = model.nm_empresa
        formRef.current.razaosocial.value = model.rz_social
        formRef.current.ramoatividade.value = model.ramo_atividade
        formRef.current.naturezalegal.value = model.natureza_legal
        formRef.current.cnae.value = model.cd_cnae
        formRef.current.cep.value = model.cd_cep
        formRef.current.endereco.value = model.endereco
        formRef.current.numero.value = model.numero
        formRef.current.complemento.value = model.complemento
        formRef.current.bairro.value = model.bairro
        formRef.current.uf.value = model.estado
        formRef.current.cidade.value = model.cidade
        formRef.current.nomecompleto.value = model.nm_responsavel
        formRef.current.cargo.value = model.cargo_responsavel
        formRef.current.celular.value = model.nu_celular
        formRef.current.telefonecomercial.value = model.nu_tel_comercial
        formRef.current.email.value = model.str_email
        formRef.current.siteempresa.value = model.str_site_empresa
        
        setInputState({
            nomesocio: true,
            cnpj: true,
            nomeempresa: true,
            razaosocial: true,
            naturezalegal: true,
            cep: true,
            endereco: true,
            numero: true,
            complemento: true,
            bairro: true,
            uf: true,
            cidade: true,
            nomecompleto: true,
            cargo: true,
            celular: true,
            telefonecomercial: true,
            email: true,
            siteempresa: true,
            ramoatividade: true,
            cnae: true
        })
    }

    useEffect(()=> {
        if(data!=undefined && data.hasError==false){
            setInputs(data.model)
        }
    }, [data, error])
    useEffect(() => {
        setIsValid(true);
        for (const v of Object.values(inputState)) {
            if (v === false) {
                setIsValid(false);
                break;
            }
        }
    }, [inputState])

    const onSubmit = async (e) => {
        e.preventDefault();
        if(isValid){
            registerCompanyData(e.target)
        }

    }

    const [apiError, setApiError] = useState("")
    function registerCompanyData(form){
        setLoadingSend(true);
        var data= JSON.stringify(
            {
                "nm_socio": form.nomesocio.value,
                "cd_cnpj": form.cnpj.value.replace("-", "").replace(".", "").replace("/", ""),
                "nm_empresa": form.nomeempresa.value,
                "rz_social": form.razaosocial.value ,
                "ramo_atividade": form.ramoatividade.value,
                "natureza_legal": form.naturezalegal.value,
                "cd_cnae": form.cnae.value,
                "cd_cep": form.cep.value,
                "endereco": form.endereco.value,
                "numero": form.numero.value,
                "complemento": form.complemento.value,
                "bairro": form.bairro.value,
                "estado": form.uf.value,
                "cidade": form.cidade.value,
                "nm_responsavel": form.nomecompleto.value,
                "cargo_responsavel": form.cargo.value,
                "nu_celular": form.celular.value,
                "nu_tel_comercial": form.telefonecomercial.value,
                "str_email": form.email.value,
                "str_site_empresa": form.siteempresa.value
                
              }
        )
        fetch(process.env.REACT_APP_API_URL+'Register_CompanyData',
            {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                method: "POST",
                body: data
            })
            .then((response)=>{ 
                response.json().then((json)=>{
                    console.log(json)
                    if(json.hasError===false) {
                        localStorage.setItem("idEmpresa",json.model.idEmpresa)
                        nextStep();
                    }else{
                        setApiError(json.description)
                        setTimeout(() => {setApiError("")}, 1500)
                    }
                })

            }).finally(()=>{setLoadingSend(false);})

    }

    function validationSearchParams(isEmail,e){
        let value=e.target.value
        SetSearchParam(value.replace("-", "").replace(".", "").replace("/", ""))
    }


    return (
        <form ref={formRef} className='conta-content' onSubmit={onSubmit}>
            <div className='conta-content-section'>
                <h2 className="conta-section-title">Dados da Empresa</h2>
                <div className="form-section">
                    <div className="form-section-row">
                        <FormInput id="nomesocio" label={"Nome do sócio"}
                            validators={[
                                { func: sizeValidator, argument: 1 }
                            ]}
                            mask={
                                letraMask
                            }
                            updateField={updateField}
                        />

                        <FormInput id="cnpj" label={"CNPJ"}
                            onBlur={(e) => {validationSearchParams(false,e)}}
                            validators={[
                                { func: cnpjValidator, argument: 14 }
                            ]}
                            mask={
                                cnpjMask
                            }
                            updateField={updateField} />
                    </div>

                    <div className="form-section-row">
                        <FormInput id="nomeempresa" label={"Nome da empresa"}
                            validators={[
                                { func: sizeValidator, argument: 1 }
                            ]}

                            updateField={updateField}
                        />

                        <FormInput id="razaosocial" label={"Razão Social"} updateField={updateField}
                            validators={[
                                { func: sizeValidator, argument: 1 }
                            ]}
                        />
                    </div>

                    <div className="form-section-row">
                        <FormSelect id="ramoatividade" label="Ramo de atividade"
                            defaultValue=""
                            updateField={updateField}
                            validators={[
                                {func:requiredSelectValidator}
                            ]}
                            onChange={(() => {})}
                        >
                            <option value="Alimentos e Bebidas">Alimentos e Bebidas</option>
                            <option value="Arte e Antiguidades">Arte e Antiguidades</option>
                            <option value="Artigos Religiosos">Artigos Religiosos</option>
                            <option value="Assinaturas e Revistas">Assinaturas e Revistas</option>
                            <option value="Automóveis e Veículos">Automóveis e Veículos</option>
                            <option value="Bebês e Cia">Bebês e Cia</option>
                            <option value="Brindes / Materiais Promocionais">Brindes / Materiais Promocionais</option>
                            <option value="Brinquedos e Games">Brinquedos e Games</option>
                            <option value="Casa e Decoração">Casa e Decoração</option>
                            <option value="Colecionáveis">Colecionáveis</option>
                            <option value="Compras Coletivas">Compras Coletivas</option>
                            <option value="Construção e Ferramentas">Construção e Ferramentas</option>
                            <option value="Cosméticos e Perfumaria">Cosméticos e Perfumaria</option>
                            <option value="Cursos e Educação">Cursos e Educação</option>
                            <option value="Eletrodomésticos">Eletrodomésticos</option>
                            <option value="Eletrônicos">Eletrônicos</option>
                            <option value="Emissoras de Rádio">Emissoras de Rádio</option>
                            <option value="Emissoras de Televisão">Emissoras de Televisão</option>
                            <option value="Empregos">Empregos</option>
                            <option value="Empresas de Telemarketing">Empresas de Telemarketing</option>
                            <option value="Esporte e Lazer">Esporte e Lazer</option>
                            <option value="Fitas K7 Gravadas">Fitas K7 Gravadas</option>
                            <option value="Flores, Cestas e Presentes">Flores, Cestas e Presentes</option>
                            <option value="Fotografia">Fotografia</option>
                            <option value="Igrejas / Templos / Instituições Religiosas">Igrejas / Templos / Instituições Religiosas</option>
                            <option value="Indústria, Comércio e Negócios">Indústria, Comércio e Negócios</option>
                            <option value="Infláveis Promocionais">Infláveis Promocionais</option>
                            <option value="Informática">Informática</option>
                            <option value="Ingressos">Ingressos</option>
                            <option value="Instrumentos Musicais">Instrumentos Musicais</option>
                            <option value="Joalheria">Joalheria</option>
                            <option value="Lazer">Lazer</option>
                            <option value="Livros">Livros</option>
                            <option value="Moda e Acessórios">Moda e Acessórios</option>
                            <option value="Motéis">Motéis</option>
                            <option value="Música Digital">Música Digital</option>
                            <option value="Natal">Natal</option>
                            <option value="Negócios e Oportunidades">Negócios e Oportunidades</option>
                            <option value="Outros Serviços">Outros Serviços</option>
                            <option value="Outros Serviços de Avaliação">Outros Serviços de Avaliação</option>
                            <option value="Papelaria e Escritório">Papelaria e Escritório</option>
                            <option value="Pet Shop">Pet Shop</option>
                            <option value="Saúde">Saúde</option>
                            <option value="Serviço Advocaticios">Serviço Advocaticios</option>
                            <option value="Serviço de Distribuição de Jornais / Revistas">Serviço de Distribuição de Jornais / Revistas</option>
                            <option value="Serviços Administrativos">Serviços Administrativos</option>
                            <option value="Serviços Artísticos">Serviços Artísticos</option>
                            <option value="Serviços de Abatedouros / Matadouros">Serviços de Abatedouros / Matadouros</option>
                            <option value="Serviços de Aeroportos">Serviços de Aeroportos</option>
                            <option value="Serviços de Agências">Serviços de Agências</option>
                            <option value="Serviços de Aluguel / Locação">Serviços de Aluguel / Locação</option>
                            <option value="Serviços de Armazenagem">Serviços de Armazenagem</option>
                            <option value="Serviços de Assessorias">Serviços de Assessorias</option>
                            <option value="Serviços de Assistência Técnica / Instalações">Serviços de Assistência Técnica / Instalações</option>
                            <option value="Serviços de Associações">Serviços de Associações</option>
                            <option value="Serviços de Bancos de Sangue">Serviços de Bancos de Sangue</option>
                            <option value="Serviços de Bibliotecas">Serviços de Bibliotecas</option>
                            <option value="Serviços de Cartórios">Serviços de Cartórios</option>
                            <option value="Serviços de Casas Lotéricas">Serviços de Casas Lotéricas</option>
                            <option value="Serviços de Confecções">Serviços de Confecções</option>
                            <option value="Serviços de Consórcios">Serviços de Consórcios</option>
                            <option value="Serviços de Consultorias">Serviços de Consultorias</option>
                            <option value="Serviços de Cooperativas">Serviços de Cooperativas</option>
                            <option value="Serviços de Despachante">Serviços de Despachante</option>
                            <option value="Serviços de Engenharia">Serviços de Engenharia</option>
                            <option value="Serviços de Estacionamentos">Serviços de Estacionamentos</option>
                            <option value="Serviços de Estaleiros">Serviços de Estaleiros</option>
                            <option value="Serviços de Exportação / Importação">Serviços de Exportação / Importação</option>
                            <option value="Serviços de Geólogos">Serviços de Geólogos</option>
                            <option value="Serviços de joalheiros">Serviços de joalheiros</option>
                            <option value="Serviços de Leiloeiros">Serviços de Leiloeiros</option>
                            <option value="Serviços de limpeza">Serviços de limpeza</option>
                            <option value="Serviços de Loja de Conveniência">Serviços de Loja de Conveniência</option>
                            <option value="Serviços de Mão de Obra">Serviços de Mão de Obra</option>
                            <option value="Serviços de Órgão Públicos">Serviços de Órgão Públicos</option>
                            <option value="Serviços de Pesquisas">Serviços de Pesquisas</option>
                            <option value="Serviços de Portos">Serviços de Portos</option>
                            <option value="Serviços de Saúde / Bem Estar">Serviços de Saúde / Bem Estar</option>
                            <option value="Serviços de Seguradoras">Serviços de Seguradoras</option>
                            <option value="Serviços de Segurança">Serviços de Segurança</option>
                            <option value="Serviços de Sinalização">Serviços de Sinalização</option>
                            <option value="Serviços de Sindicatos / Federações">Serviços de Sindicatos / Federações</option>
                            <option value="Serviços de Traduções">Serviços de Traduções</option>
                            <option value="Serviços de Transporte">Serviços de Transporte</option>
                            <option value="Serviços de Utilidade Pública">Serviços de Utilidade Pública</option>
                            <option value="Serviços em Agricultura / Pecuária / Piscicultura">Serviços em Agricultura / Pecuária / Piscicultura</option>
                            <option value="Serviços em Alimentação">Serviços em Alimentação</option>
                            <option value="Serviços em Arte">Serviços em Arte</option>
                            <option value="Serviços em Cine / Foto / Som">Serviços em Cine / Foto / Som</option>
                            <option value="Serviços em Comunicação">Serviços em Comunicação</option>
                            <option value="Serviços em Construção">Serviços em Construção</option>
                            <option value="Serviços em Ecologia / Meio Ambiente">Serviços em Ecologia / Meio Ambiente</option>
                            <option value="Serviços em Eletroeletrônica / Metal Mecânica">Serviços em Eletroeletrônica / Metal Mecânica</option>
                            <option value="Serviços em Festas / Eventos">Serviços em Festas / Eventos</option>
                            <option value="Serviços em Informática">Serviços em Informática</option>
                            <option value="Serviços em Internet">Serviços em Internet</option>
                            <option value="Serviços em Jóias / Relógios / Óticas">Serviços em Jóias / Relógios / Óticas</option>
                            <option value="Serviços em Telefonia">Serviços em Telefonia</option>
                            <option value="Serviços em Veículos">Serviços em Veículos</option>
                            <option value="Serviços Esotéricos / Místicos">Serviços Esotéricos / Místicos</option>
                            <option value="Serviços Financeiros">Serviços Financeiros</option>
                            <option value="Serviços Funerários">Serviços Funerários</option>
                            <option value="Serviços Gerais">Serviços Gerais</option>
                            <option value="Serviços Gráficos / Editoriais">Serviços Gráficos / Editoriais</option>
                            <option value="Serviços para Animais">Serviços para Animais</option>
                            <option value="Serviços para Deficientes">Serviços para Deficientes</option>
                            <option value="Serviços para Escritórios">Serviços para Escritórios</option>
                            <option value="Serviços para Roupas">Serviços para Roupas</option>
                            <option value="Serviços Socias / Assistenciais">Serviços Socias / Assistenciais</option>
                            <option value="Sex Shop">Sex Shop</option>
                            <option value="Shopping Centers">Shopping Centers</option>
                            <option value="Tabacaria">Tabacaria</option>
                            <option value="Tarifas Bancárias">Tarifas Bancárias</option>
                            <option value="Tarifas Telefônicas">Tarifas Telefônicas</option>
                            <option value="Telefonia">Telefonia</option>
                            <option value="Turismo">Turismo</option>
                        </FormSelect>

                        <FormInput id="naturezalegal" label={"Natureza Legal"} updateField={updateField}
                            validators={[
                                { func: sizeValidator, argument: 1 }
                            ]}
                        />
                    </div>

                    <FormSelect id="cnae" label="Atividade econômica principal (CNAE)"
                        defaultValue=""
                        updateField={updateField}
                        validators={[
                            {func:requiredSelectValidator}
                        ]}
                    >
                        <option value="0111-3/01 Cultivo de arroz"> 0111-3/01 Cultivo de arroz </option>
<option> 0111-3/02 Cultivo de milho </option>
<option> 0111-3/03 Cultivo de trigo </option>
<option> 0111-3/99 Cultivo de outros cereais não especificados anteriormente </option>
<option> 0112-1/01 Cultivo de algodão herbáceo </option>
<option> 0112-1/02 Cultivo de juta </option>
<option> 0112-1/99 Cultivo de outras fibras de lavoura temporária não especificadas anteriormente </option>
<option> 0113-0/00 Cultivo de cana-de-açúcar </option>
<option> 0114-8/00 Cultivo de fumo </option>
<option> 0115-6/00 Cultivo de soja </option>
<option> 0116-4/01 Cultivo de amendoim </option>
<option> 0116-4/02 Cultivo de girassol </option>
<option> 0116-4/03 Cultivo de mamona </option>
<option> 0116-4/99 Cultivo de outras oleaginosas de lavoura temporária não especificadas anteriormente </option>
<option> 0119-9/01 Cultivo de abacaxi </option>
<option> 0119-9/02 Cultivo de alho </option>
<option> 0119-9/03 Cultivo de batata-inglesa </option>
<option> 0119-9/04 Cultivo de cebola </option>
<option> 0119-9/05 Cultivo de feijão </option>
<option> 0119-9/06 Cultivo de mandioca </option>
<option> 0119-9/07 Cultivo de melão </option>
<option> 0119-9/08 Cultivo de melancia </option>
<option> 0119-9/09 Cultivo de tomate rasteiro </option>
<option> 0119-9/99 Cultivo de outras plantas de lavoura temporária não especificadas anteriormente </option>
<option> 0121-1/01 Horticultura, exceto morango </option>
<option> 0121-1/02 Cultivo de morango </option>
<option> 0122-9/00 Floricultura </option>
<option> 0131-8/00 Cultivo de laranja </option>
<option> 0132-6/00 Cultivo de uva </option>
<option> 0133-4/01 Cultivo de açaí </option>
<option> 0133-4/02 Cultivo de banana </option>
<option> 0133-4/03 Cultivo de caju </option>
<option> 0133-4/04 Cultivo de cítricos, exceto laranja </option>
<option> 0133-4/05 Cultivo de coco-da-baía </option>
<option> 0133-4/06 Cultivo de guaraná </option>
<option> 0133-4/07 Cultivo de maçã </option>
<option> 0133-4/08 Cultivo de mamão </option>
<option> 0133-4/09 Cultivo de maracujá </option>
<option> 0133-4/10 Cultivo de manga </option>
<option> 0133-4/11 Cultivo de pêssego </option>
<option> 0133-4/99 Cultivo de frutas de lavoura permanente não especificadas anteriormente </option>
<option> 0134-2/00 Cultivo de café </option>
<option> 0135-1/00 Cultivo de cacau </option>
<option> 0139-3/01 Cultivo de chá-da-índia </option>
<option> 0139-3/02 Cultivo de erva-mate </option>
<option> 0139-3/03 Cultivo de pimenta-do-reino </option>
<option> 0139-3/04 Cultivo de plantas para condimento, exceto pimenta-do-reino </option>
<option> 0139-3/05 Cultivo de dendê </option>
<option> 0139-3/06 Cultivo de seringueira </option>
<option> 0139-3/99 Cultivo de outras plantas de lavoura permanente não especificadas anteriormente </option>
<option> 0141-5/01 Produção de sementes certificadas, exceto de forrageiras para pasto </option>
<option> 0141-5/02 Produção de sementes certificadas de forrageiras para formação de pasto </option>
<option> 0142-3/00 Produção de mudas e outras formas de propagação vegetal, certificadas </option>
<option> 0151-2/01 Criação de bovinos para corte </option>
<option> 0151-2/02 Criação de bovinos para leite </option>
<option> 0151-2/03 Criação de bovinos, exceto para corte e leite </option>
<option> 0152-1/01 Criação de bufalinos </option>
<option> 0152-1/02 Criação de eqüinos </option>
<option> 0152-1/03 Criação de asininos e muares </option>
<option> 0153-9/01 Criação de caprinos </option>
<option> 0153-9/02 Criação de ovinos, inclusive para produção de lã </option>
<option> 0154-7/00 Criação de suínos </option>
<option> 0155-5/01 Criação de frangos para corte </option>
<option> 0155-5/02 Produção de pintos de um dia </option>
<option> 0155-5/03 Criação de outros galináceos, exceto para corte </option>
<option> 0155-5/04 Criação de aves, exceto galináceos </option>
<option> 0155-5/05 Produção de ovos </option>
<option> 0159-8/01 Apicultura </option>
<option> 0159-8/02 Criação de animais de estimação </option>
<option> 0159-8/03 Criação de escargô </option>
<option> 0159-8/04 Criação de bicho-da-seda </option>
<option> 0159-8/99 Criação de outros animais não especificados anteriormente </option>
<option> 0161-0/01 Serviço de pulverização e controle de pragas agrícolas </option>
<option> 0161-0/02 Serviço de poda de árvores para lavouras </option>
<option> 0161-0/03 Serviço de preparação de terreno, cultivo e colheita </option>
<option> 0161-0/99 Atividades de apoio à agricultura não especificadas anteriormente </option>
<option> 0162-8/01 Serviço de inseminação artificial de animais * </option>
<option> 0162-8/02 Serviço de tosquiamento de ovinos </option>
<option> 0162-8/03 Serviço de manejo de animais </option>
<option> 0162-8/99 Atividades de apoio à pecuária não especificadas anteriormente </option>
<option> 0163-6/00 Atividades de pós-colheita </option>
<option> 0170-9/00 Caça e serviços relacionados </option>
<option> 0210-1/01 Cultivo de eucalipto </option>
<option> 0210-1/02 Cultivo de acácia-negra </option>
<option> 0210-1/03 Cultivo de pinus </option>
<option> 0210-1/04 Cultivo de teca </option>
<option> 0210-1/05 Cultivo de espécies madeireiras, exceto eucalipto, acácia-negra, pinus e teca </option>
<option> 0210-1/06 Cultivo de mudas em viveiros florestais </option>
<option> 0210-1/07 Extração de madeira em florestas plantadas </option>
<option> 0210-1/08 Produção de carvão vegetal - florestas plantadas </option>
<option> 0210-1/09 Produção de casca de acácia-negra - florestas plantadas </option>
<option> 0210-1/99 Produção de produtos não-madeireiros não especificados anteriormente em florestas plantadas </option>
<option> 0220-9/01 Extração de madeira em florestas nativas </option>
<option> 220-9/02  Produção de carvão vegetal - florestas nativas </option>
<option> 0220-9/03 Coleta de castanha-do-pará em florestas nativas </option>
<option> 0220-9/04 Coleta de látex em florestas nativas </option>
<option> 0220-9/05 Coleta de palmito em florestas nativas </option>
<option> 0220-9/06 Conservação de florestas nativas </option>
<option> 0220-9/99 Coleta de produtos não-madeireiros não especificados anteriormente em florestas nativas </option>
<option> 0230-6/00 Atividades de apoio à produção florestal </option>
<option> 0311-6/01 Pesca de peixes em água salgada </option>
<option> 0311-6/02 Pesca de crustáceos e moluscos em água salgada </option>
<option> 0311-6/03 Coleta de outros produtos marinhos </option>
<option> 0311-6/04 Atividades de apoio à pesca em água salgada </option>
<option> 0312-4/01 Pesca de peixes em água doce </option>
<option> 0312-4/02 Pesca de crustáceos e moluscos em água doce </option>
<option> 0312-4/03 Coleta de outros produtos aquáticos de água doce </option>
<option> 0312-4/04 Atividades de apoio à pesca em água doce </option>
<option> 0321-3/01 Criação de peixes em água salgada e salobra </option>
<option> 0321-3/02 Criação de camarões em água salgada e salobra </option>
<option> 0321-3/03 Criação de ostras e mexilhões em água salgada e salobra </option>
<option> 0321-3/04 Criação de peixes ornamentais em água salgada e salobra </option>
<option> 0321-3/05 Atividades de apoio à aqüicultura em água salgada e salobra </option>
<option> 0321-3/99 Cultivos e semicultivos da aqüicultura em água salgada e salobra não especificados anteriormente </option>
<option> 0322-1/01 Criação de peixes em água doce </option>
<option> 0322-1/02 Criação de camarões em água doce </option>
<option> 0322-1/03 Criação de ostras e mexilhões em água doce </option>
<option> 0322-1/04 Criação de peixes ornamentais em água doce </option>
<option> 0322-1/05 Ranicultura </option>
<option> 0322-1/06 Criação de jacaré </option>
<option> 0322-1/07 Atividades de apoio à aqüicultura em água doce </option>
<option> 0322-1/99 Cultivos e semicultivos da aqüicultura em água doce não especificados anteriormente </option>
<option> 0500-3/01 Extração de carvão mineral </option>
<option> 0500-3/02 Beneficiamento de carvão mineral </option>
<option> 0600-0/01 Extração de petróleo e gás natural </option>
<option> 0600-0/02 Extração e beneficiamento de xisto </option>
<option> 0600-0/03 Extração e beneficiamento de areias betuminosas </option>
<option> 0710-3/01 Extração de minério de ferro </option>
<option> 0710-3/02 Pelotização, sinterização e outros beneficiamentos de minério de ferro </option>
<option> 0721-9/01 Extração de minério de alumínio </option>
<option> 0721-9/02 Beneficiamento de minério de alumínio </option>
<option> 0722-7/01 Extração de minério de estanho </option>
<option> 0722-7/02 Beneficiamento de minério de estanho </option>
<option> 0723-5/01 Extração de minério de manganês </option>
<option> 0723-5/02 Beneficiamento de minério de manganês </option>
<option> 0724-3/01 Extração de minério de metais preciosos </option>
<option> 0724-3/02 Beneficiamento de minério de metais preciosos </option>
<option> 0725-1/00 Extração de minerais radioativos </option>
<option> 0729-4/01 Extração de minérios de nióbio e titânio </option>
<option> 0729-4/02 Extração de minério de tungstênio </option>
<option> 0729-4/03 Extração de minério de níquel </option>
<option> 0810-0/01 Extração de ardósia e beneficiamento associado </option>
<option> 0810-0/02 Extração de granito e beneficiamento associado </option>
<option> 0810-0/03 Extração de mármore e beneficiamento associado </option>
<option> 0810-0/04 Extração de calcário e dolomita e beneficiamento associado </option>
<option> 0810-0/05 Extração de gesso e caulim </option>
<option> 0810-0/06 Extração de areia, cascalho ou pedregulho e beneficiamento associado </option>
<option> 0810-0/07 Extração de argila e beneficiamento associado </option>
<option> 0810-0/08 Extração de saibro e beneficiamento associado </option>
<option> 0810-0/09 Extração de basalto e beneficiamento associado </option>
<option> 0810-0/10 Beneficiamento de gesso e caulim associado à extração </option>
<option> 0810-0/99 Extração e britamento de pedras e outros materiais para construção e beneficiamento associado </option>
<option> 0891-6/00 Extração de minerais para fabricação de adubos, fertilizantes e outros produtos químicos </option>
<option> 0892-4/01 Extração de sal marinho </option>
<option> 0892-4/02 Extração de sal-gema </option>
<option> 0892-4/03 Refino e outros tratamentos do sal </option>
<option> 0893-2/00 Extração de gemas (pedras preciosas e semipreciosas) </option>
<option> 0899-1/01 Extração de grafita </option>
<option> 0899-1/02 Extração de quartzo </option>
<option> 0899-1/03 Extração de amianto </option>
<option> 0899-1/99 Extração de outros minerais não-metálicos não especificados anteriormente </option>
<option> 0910-6/00 Atividades de apoio à extração de petróleo e gás natural </option>
<option> 0990-4/01 Atividades de apoio à extração de minério de ferro </option>
<option> 0990-4/02 Atividades de apoio à extração de minerais metálicos não-ferrosos </option>
<option> 0990-4/03 Atividades de apoio à extração de minerais não-metálicos </option>
<option> 1011-2/01 Frigorífico - abate de bovinos </option>
<option> 1011-2/02 Frigorífico - abate de eqüinos </option>
<option> 1011-2/03 Frigorífico - abate de ovinos e caprinos </option>
<option> 1011-2/04 Frigorífico - abate de bufalinos </option>
<option> 1011-2/05 Matadouro - abate de reses sob contrato - exceto abate de suínos </option>
<option> 1012-1/01 Abate de aves </option>
<option> 1012-1/02 Abate de pequenos animais </option>
<option> 1012-1/03 Frigorífico - abate de suínos </option>
<option> 1012-1/04 Matadouro - abate de suínos sob contrato </option>
<option> 1013-9/01 Fabricação de produtos de carne </option>
<option> 1013-9/02 Preparação de subprodutos do abate </option>
<option> 1020-1/01 Preservação de peixes, crustáceos e moluscos </option>
<option> 1020-1/02 Fabricação de conservas de peixes, crustáceos e moluscos </option>
<option> 1031-7/00 Fabricação de conservas de frutas </option>
<option> 1032-5/01 Fabricação de conservas de palmito </option>
<option> 1032-5/99 Fabricação de conservas de legumes e outros vegetais, exceto palmito </option>
<option> 1033-3/01 Fabricação de sucos concentrados de frutas, hortaliças e legumes </option>
<option> 1033-3/02 Fabricação de sucos de frutas, hortaliças e legumes, exceto concentrados </option>
<option> 1041-4/00 Fabricação de óleos vegetais em bruto, exceto óleo de milho </option>
<option> 1042-2/00 Fabricação de óleos vegetais refinados, exceto óleo de milho </option>
<option> 1043-1/00 Fabricação de margarina e outras gorduras vegetais e de óleos não-comestíveis de animais </option>
<option> 1051-1/00 Preparação do leite </option>
<option> 1052-0/00 Fabricação de laticínios </option>
<option> 1053-8/00 Fabricação de sorvetes e outros gelados comestíveis </option>
<option> 1061-9/01 Beneficiamento de arroz </option>
<option> 1061-9/02 Fabricação de produtos do arroz </option>
<option> 1062-7/00 Moagem de trigo e fabricação de derivados </option>
<option> 1063-5/00 Fabricação de farinha de mandioca e derivados </option>
<option> 1064-3/00 Fabricação de farinha de milho e derivados, exceto óleos de milho </option>
<option> 1065-1/01 Fabricação de amidos e féculas de vegetais </option>
<option> 1065-1/02 Fabricação de óleo de milho em bruto </option>
<option> 1065-1/03 Fabricação de óleo de milho refinado </option>
<option> 1066-0/00 Fabricação de alimentos para animais </option>
<option> 1069-4/00 Moagem e fabricação de produtos de origem vegetal não especificados anteriormente </option>
<option> 1071-6/00 Fabricação de açúcar em bruto </option>
<option> 1072-4/01 Fabricação de açúcar de cana refinado </option>
<option> 1072-4/02 Fabricação de açúcar de cereais (dextrose) e de beterraba </option>
<option> 1081-3/01 Beneficiamento de café </option>
<option> 1081-3/02 Torrefação e moagem de café </option>
<option> 1082-1/00 Fabricação de produtos à base de café </option>
<option> 1091-1/01 Fabricação de produtos de panificação industrial </option>
<option> 1091-1/02 Padaria e confeitaria com predominância de produção própria </option>
<option> 1092-9/00 Fabricação de biscoitos e bolachas </option>
<option> 1093-7/01 Fabricação de produtos derivados do cacau e de chocolates </option>
<option> 1093-7/02 Fabricação de frutas cristalizadas, balas e semelhantes </option>
<option> 1094-5/00 Fabricação de massas alimentícias </option>
<option> 1095-3/00 Fabricação de especiarias, molhos, temperos e condimentos </option>
<option> 1096-1/00 Fabricação de alimentos e pratos prontos </option>
<option> 1099-6/01 Fabricação de vinagres </option>
<option> 1099-6/02 Fabricação de pós alimentícios </option>
<option> 1099-6/03 Fabricação de fermentos e leveduras </option>
<option> 1099-6/04 Fabricação de gelo comum </option>
<option> 1099-6/05 Fabricação de produtos para infusão (chá, mate, etc.) </option>
<option> 1099-6/06 Fabricação de adoçantes naturais e artificiais </option>
<option> 1099-6/07 Fabricação de alimentos dietéticos e complementos alimentares </option>
<option> 1099-6/99 Fabricação de outros produtos alimentícios não especificados anteriormente </option>
<option> 1111-9/01 Fabricação de aguardente de cana-de-açúcar </option>
<option> 1111-9/02 Fabricação de outras aguardentes e bebidas destiladas </option>
<option> 1112-7/00 Fabricação de vinho </option>
<option> 1113-5/01 Fabricação de malte, inclusive malte uísque </option>
<option> 1113-5/02 Fabricação de cervejas e chopes </option>
<option> 1121-6/00 Fabricação de águas envasadas </option>
<option> 1122-4/01 Fabricação de refrigerantes </option>
<option> 1122-4/02 Fabricação de chá mate e outros chás prontos para consumo </option>
<option> 1122-4/03 Fabricação de refrescos, xaropes e pós para refrescos, exceto refrescos de frutas </option>
<option> 1122-4/04 Fabricação de bebidas isotônicas </option>
<option> 1122-4/99 Fabricação de outras bebidas não-alcoólicas não especificadas anteriormente </option>
<option> 1210-7/00 Processamento industrial do fumo </option>
<option> 1220-4/01 Fabricação de cigarros </option>
<option> 1220-4/02 Fabricação de cigarrilhas e charutos </option>
<option> 1220-4/03 Fabricação de filtros para cigarros </option>
<option> 1220-4/99 Fabricação de outros produtos do fumo, exceto cigarros, cigarrilhas e charutos </option>
<option> 1311-1/00 Preparação e fiação de fibras de algodão </option>
<option> 1312-0/00 Preparação e fiação de fibras têxteis naturais, exceto algodão </option>
<option> 1313-8/00 Fiação de fibras artificiais e sintéticas </option>
<option> 1314-6/00 Fabricação de linhas para costurar e bordar </option>
<option> 1321-9/00 Tecelagem de fios de algodão </option>
<option> 1322-7/00 Tecelagem de fios de fibras têxteis naturais, exceto algodão </option>
<option> 1323-5/00 Tecelagem de fios de fibras artificiais e sintéticas </option>
<option> 1330-8/00 Fabricação de tecidos de malha </option>
<option> 1340-5/01 Estamparia e texturização em fios, tecidos, artefatos têxteis e peças do vestuário </option>
<option> 1340-5/02 Alvejamento, tingimento e torção em fios, tecidos, artefatos têxteis e peças do vestuário </option>
<option> 1340-5/99 Outros serviços de acabamento em fios, tecidos, artefatos têxteis e peças do vestuário </option>
<option> 1351-1/00 Fabricação de artefatos têxteis para uso doméstico </option>
<option> 1352-9/00 Fabricação de artefatos de tapeçaria </option>
<option> 1353-7/00 Fabricação de artefatos de cordoaria </option>
<option> 1354-5/00 Fabricação de tecidos especiais, inclusive artefatos </option>
<option> 1359-6/00 Fabricação de outros produtos têxteis não especificados anteriormente </option>
<option> 1411-8/01 Confecção de roupas íntimas </option>
<option> 1411-8/02 Facção de roupas íntimas </option>
<option> 1412-6/01 Confecção de peças do vestuário, exceto roupas íntimas e as confeccionadas sob medida </option>
<option> 1412-6/02 Confecção, sob medida, de peças do vestuário, exceto roupas íntimas </option>
<option> 1412-6/03 Facção de peças do vestuário, exceto roupas íntimas </option>
<option> 1413-4/01 Confecção de roupas profissionais, exceto sob medida </option>
<option> 1413-4/02 Confecção, sob medida, de roupas profissionais </option>
<option> 1413-4/03 Facção de roupas profissionais </option>
<option> 1414-2/00 Fabricação de acessórios do vestuário, exceto para segurança e proteção </option>
<option> 1421-5/00 Fabricação de meias </option>
<option> 1422-3/00 Fabricação de artigos do vestuário, produzidos em malharias e tricotagens, exceto meias </option>
<option> 1510-6/00 Curtimento e outras preparações de couro </option>
<option> 1521-1/00 Fabricação de artigos para viagem, bolsas e semelhantes de qualquer material </option>
<option> 1529-7/00 Fabricação de artefatos de couro não especificados anteriormente </option>
<option> 1531-9/01 Fabricação de calçados de couro </option>
<option> 1531-9/02 Acabamento de calçados de couro sob contrato </option>
<option> 1532-7/00 Fabricação de tênis de qualquer material </option>
<option> 1533-5/00 Fabricação de calçados de material sintético </option>
<option> 1539-4/00 Fabricação de calçados de materiais não especificados anteriormente </option>
<option> 1540-8/00 Fabricação de partes para calçados, de qualquer material </option>
<option> 1610-2/01 Serrarias com desdobramento de madeira </option>
<option> 1610-2/02 Serrarias sem desdobramento de madeira </option>
<option> 1621-8/00 Fabricação de madeira laminada e de chapas de madeira compensada, prensada e aglomerada </option>
<option> 1622-6/01 Fabricação de casas de madeira pré-fabricadas </option>
<option> 1622-6/02 Fabricação de esquadrias de madeira e de peças de madeira para instalações industriais e comerciais </option>
<option> 1622-6/99 Fabricação de outros artigos de carpintaria para construção </option>
<option> 1623-4/00 Fabricação de artefatos de tanoaria e de embalagens de madeira </option>
<option> 1629-3/01 Fabricação de artefatos diversos de madeira, exceto móveis </option>
<option> 1629-3/02 Fabricação de artefatos diversos de cortiça, bambu, palha, vime e outros materiais trançados, exceto móveis </option>
<option> 1710-9/00 Fabricação de celulose e outras pastas para a fabricação de papel </option>
<option> 1721-4/00 Fabricação de papel </option>
<option> 1722-2/00 Fabricação de cartolina e papel-cartão </option>
<option> 1731-1/00 Fabricação de embalagens de papel </option>
<option> 1732-0/00 Fabricação de embalagens de cartolina e papel-cartão </option>
<option> 1733-8/00 Fabricação de chapas e de embalagens de papelão ondulado </option>
<option> 1741-9/01 Fabricação de formulários contínuos </option>
<option> 1742-7/01 Fabricação de fraldas descartáveis </option>
<option> 1742-7/02 Fabricação de absorventes higiênicos </option>
<option> 1742-7/99 Fabricação de produtos de papel para uso doméstico e higiênico-sanitário não especificados anteriormente </option>
<option> 1811-3/01 Impressão de jornais </option>
<option> 1811-3/02 Impressão de livros, revistas e outras publicações periódicas </option>
<option> 1812-1/00 Impressão de material de segurança </option>
<option> 1813-0/01 Impressão de material para uso publicitário </option>
<option> 1813-0/99 Impressão de material para outros usos </option>
<option> 1821-1/00 Serviços de pré-impressão </option>
<option> 1822-9/01 Serviços de encadernação e plastificação </option>
<option> 1822-9/99 Serviços de acabamentos gráficos, exceto encadernação e plastificação </option>
<option> 1830-0/01 Reprodução de som em qualquer suporte </option>
<option> 1830-0/02 Reprodução de vídeo em qualquer suporte </option>
<option> 1830-0/03 Reprodução de software em qualquer suporte </option>
<option> 1910-1/00 Coquerias </option>
<option> 1921-7/00 Fabricação de produtos do refino de petróleo </option>
<option> 1922-5/01 Formulação de combustíveis </option>
<option> 1922-5/02 Rerrefino de óleos lubrificantes </option>
<option> 1922-5/99 Fabricação de outros produtos derivados do petróleo, exceto produtos do refino </option>
<option> 1931-4/00 Fabricação de álcool </option>
<option> 1932-2/00 Fabricação de biocombustíveis, exceto álcool </option>
<option> 2011-8/00 Fabricação de cloro e álcalis </option>
<option> 2012-6/00 Fabricação de intermediários para fertilizantes </option>
<option> 2013-4/01 Fabricação de adubos e fertilizantes organo-minerais </option>
<option> 2013-4/02 Fabricação de adubos e fertilizantes, exceto organo-minerais </option>
<option> 2014-2/00 Fabricação de gases industriais </option>
<option> 2019-3/01 Elaboração de combustíveis nucleares </option>
<option> 2019-3/99 Fabricação de outros produtos químicos inorgânicos não especificados anteriormente </option>
<option> 2021-5/00 Fabricação de produtos petroquímicos básicos </option>
<option> 2022-3/00 Fabricação de intermediários para plastificantes, resinas e fibras </option>
<option> 2029-1/00 Fabricação de produtos químicos orgânicos não especificados anteriormente </option>
<option> 2031-2/00 Fabricação de resinas termoplásticas </option>
<option> 2032-1/00 Fabricação de resinas termofixas </option>
<option> 2033-9/00 Fabricação de elastômeros </option>
<option> 2040-1/00 Fabricação de fibras artificiais e sintéticas </option>
<option> 2051-7/00 Fabricação de defensivos agrícolas </option>
<option> 2052-5/00 Fabricação de desinfestantes domissanitários </option>
<option> 2061-4/00 Fabricação de sabões e detergentes sintéticos </option>
<option> 2062-2/00 Fabricação de produtos de limpeza e polimento </option>
<option> 2063-1/00 Fabricação de cosméticos, produtos de perfumaria e de higiene pessoal </option>
<option> 2071-1/00 Fabricação de tintas, vernizes, esmaltes e lacas </option>
<option> 2072-0/00 Fabricação de tintas de impressão </option>
<option> 2073-8/00 Fabricação de impermeabilizantes, solventes e produtos afins </option>
<option> 2091-6/00 Fabricação de adesivos e selantes </option>
<option> 2092-4/01 Fabricação de pólvoras, explosivos e detonantes </option>
<option> 2092-4/02 Fabricação de artigos pirotécnicos </option>
<option> 2092-4/03 Fabricação de fósforos de segurança </option>
<option> 2093-2/00 Fabricação de aditivos de uso industrial </option>
<option> 2094-1/00 Fabricação de catalisadores </option>
<option> 2099-1/01 Fabricação de chapas, filmes, papéis e outros materiais e produtos químicos para fotografia </option>
<option> 2099-1/99 Fabricação de outros produtos químicos não especificados anteriormente </option>
<option> 2110-6/00 Fabricação de produtos farmoquímicos </option>
<option> 2121-1/01 Fabricação de medicamentos alopáticos para uso humano </option>
<option> 2121-1/02 Fabricação de medicamentos homeopáticos para uso humano </option>
<option> 2121-1/03 Fabricação de medicamentos fitoterápicos para uso humano </option>
<option> 2122-0/00 Fabricação de medicamentos para uso veterinário </option>
<option> 2123-8/00 Fabricação de preparações farmacêuticas </option>
<option> 2211-1/00 Fabricação de pneumáticos e de câmaras-de-ar </option>
<option> 2212-9/00 Reforma de pneumáticos usados </option>
<option> 2219-6/00 Fabricação de artefatos de borracha não especificados anteriormente </option>
<option> 2221-8/00 Fabricação de laminados planos e tubulares de material plástico </option>
<option> 2222-6/00 Fabricação de embalagens de material plástico </option>
<option> 2223-4/00 Fabricação de tubos e acessórios de material plástico para uso na construção </option>
<option> 2229-3/01 Fabricação de artefatos de material plástico para uso pessoal e doméstico </option>
<option> 2229-3/02 Fabricação de artefatos de material plástico para usos industriais </option>
<option> 2229-3/03 Fabricação de artefatos de material plástico para uso na construção, exceto tubos e acessórios </option>
<option> 2229-3/99 Fabricação de artefatos de material plástico para outros usos não especificados anteriormente </option>
<option> 2311-7/00 Fabricação de vidro plano e de segurança </option>
<option> 2312-5/00 Fabricação de embalagens de vidro </option>
<option> 2319-2/00 Fabricação de artigos de vidro </option>
<option> 2320-6/00 Fabricação de cimento </option>
<option> 2330-3/02 Fabricação de artefatos de cimento para uso na construção </option>
<option> 2330-3/03 Fabricação de artefatos de fibrocimento para uso na construção </option>
<option> 2330-3/04 Fabricação de casas pré-moldadas de concreto </option>
<option> 2330-3/05 Preparação de massa de concreto e argamassa para construção </option>
<option> 2341-9/00 Fabricação de produtos cerâmicos refratários </option>
<option> 2342-7/01 Fabricação de azulejos e pisos </option>
<option> 2349-4/01 Fabricação de material sanitário de cerâmica </option>
<option> 2391-5/01 Britamento de pedras, exceto associado à extração </option>
<option> 2391-5/02 Aparelhamento de pedras para construção, exceto associado à extração </option>
<option> 2392-3/00 Fabricação de cal e gesso </option>
<option> 2399-1/02 Fabricação de abrasivos </option>
<option> 2411-3/00 Produção de ferro-gusa </option>
<option> 2412-1/00 Produção de ferroligas </option>
<option> 2421-1/00 Produção de semi-acabados de aço </option>
<option> 2422-9/01 Produção de laminados planos de aço ao carbono, revestidos ou não </option>
<option> 2422-9/02 Produção de laminados planos de aços especiais </option>
<option> 2423-7/01 Produção de tubos de aço sem costura </option>
<option> 2423-7/02 Produção de laminados longos de aço, exceto tubos </option>
<option> 2424-5/01 Produção de arames de aço </option>
<option> 2424-5/02 Produção de relaminados, trefilados e perfilados de aço, exceto arames </option>
<option> 2431-8/00 Produção de tubos de aço com costura </option>
<option> 2439-3/00 Produção de outros tubos de ferro e aço </option>
<option> 2441-5/01 Produção de alumínio e suas ligas em formas primárias </option>
<option> 2441-5/02 Produção de laminados de alumínio </option>
<option> 2442-3/00 Metalurgia dos metais preciosos </option>
<option> 2443-1/00 Metalurgia do cobre </option>
<option> 2449-1/01 Produção de zinco em formas primárias </option>
<option> 2449-1/02 Produção de laminados de zinco </option>
<option> 2449-1/03 Fabricação de ânodos para galvanoplastia </option>
<option> 2449-1/99 Metalurgia de outros metais não-ferrosos e suas ligas não especificados anteriormente </option>
<option> 2451-2/00 Fundição de ferro e aço </option>
<option> 2452-1/00 Fundição de metais não-ferrosos e suas ligas </option>
<option> 2511-0/00 Fabricação de estruturas metálicas </option>
<option> 2512-8/00 Fabricação de esquadrias de metal </option>
<option> 2513-6/00 Fabricação de obras de caldeiraria pesada </option>
<option> 2521-7/00 Fabricação de tanques, reservatórios metálicos e caldeiras para aquecimento central </option>
<option> 2522-5/00 Fabricação de caldeiras geradoras de vapor, exceto para aquecimento central e para veículos </option>
<option> 2531-4/01 Produção de forjados de aço </option>
<option> 2531-4/02 Produção de forjados de metais não-ferrosos e suas ligas </option>
<option> 2532-2/01 Produção de artefatos estampados de metal </option>
<option> 2532-2/02 Metalurgia do pó </option>
<option> 2539-0/01 Serviços de usinagem, tornearia e solda </option>
<option> 2539-0/02 Serviços de tratamento e revestimento em metais </option>
<option> 2541-1/00 Fabricação de artigos de cutelaria </option>
<option> 2542-0/00 Fabricação de artigos de serralheria, exceto esquadrias </option>
<option> 2543-8/00 Fabricação de ferramentas </option>
<option> 2550-1/01 Fabricação de equipamento bélico pesado, exceto veículos militares de combate </option>
<option> 2550-1/02 Fabricação de armas de fogo, outras armas e munições </option>
<option> 2591-8/00 Fabricação de embalagens metálicas </option>
<option> 2592-6/01 Fabricação de produtos de trefilados de metal padronizados </option>
<option> 2592-6/02 Fabricação de produtos de trefilados de metal, exceto padronizados </option>
<option> 2593-4/00 Fabricação de artigos de metal para uso doméstico e pessoal </option>
<option> 2599-3/01 Serviços de confecção de armações metálicas para a construção </option>
<option> 2599-3/02 Serviço de corte e dobra de metais </option>
<option> 2599-3/99 Fabricação de outros produtos de metal não especificados anteriormente </option>
<option> 2610-8/00 Fabricação de componentes eletrônicos </option>
<option> 2621-3/00 Fabricação de equipamentos de informática </option>
<option> 2622-1/00 Fabricação de periféricos para equipamentos de informática </option>
<option> 2631-1/00 Fabricação de equipamentos transmissores de comunicação, peças e acessórios </option>
<option> 2632-9/00 Fabricação de aparelhos telefônicos e de outros equipamentos de comunicação, peças e acessórios </option>
<option> 2640-0/00 Fabricação de aparelhos de recepção, reprodução, gravação e amplificação de áudio e vídeo </option>
<option> 2651-5/00 Fabricação de aparelhos e equipamentos de medida, teste e controle </option>
<option> 2652-3/00 Fabricação de cronômetros e relógios </option>
<option> 2660-4/00 Fabricação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação </option>
<option> 2670-1/01 Fabricação de equipamentos e instrumentos ópticos, peças e acessórios </option>
<option> 2670-1/02 Fabricação de aparelhos fotográficos e cinematográficos, peças e acessórios </option>
<option> 2680-9/00 Fabricação de mídias virgens, magnéticas e ópticas </option>
<option> 2710-4/01 Fabricação de geradores de corrente contínua e alternada, peças e acessórios </option>
<option> 2710-4/02 Fabricação de transformadores, indutores, conversores, sincronizadores e semelhantes, peças e acessórios </option>
<option> 2710-4/03 Fabricação de motores elétricos, peças e acessórios </option>
<option> 2721-0/00 Fabricação de pilhas, baterias e acumuladores elétricos, exceto para veículos automotores </option>
<option> 2722-8/01 Fabricação de baterias e acumuladores para veículos automotores </option>
<option> 2722-8/02 Recondicionamento de baterias e acumuladores para veículos automotores </option>
<option> 2731-7/00 Fabricação de aparelhos e equipamentos para distribuição e controle de energia elétrica </option>
<option> 2732-5/00 Fabricação de material elétrico para instalações em circuito de consumo </option>
<option> 2733-3/00 Fabricação de fios, cabos e condutores elétricos isolados </option>
<option> 2740-6/01 Fabricação de lâmpadas </option>
<option> 2740-6/02 Fabricação de luminárias e outros equipamentos de iluminação </option>
<option> 2759-7/01 Fabricação de aparelhos elétricos de uso pessoal, peças e acessórios </option>
<option> 2790-2/02 Fabricação de equipamentos para sinalização e alarme </option>
<option> 2814-3/01 Fabricação de compressores para uso industrial, peças e acessórios </option>
<option> 2814-3/02 Fabricação de compressores para uso não industrial, peças e acessórios </option>
<option> 2815-1/01 Fabricação de rolamentos para fins industriais </option>
<option> 2831-3/00 Fabricação de tratores agrícolas, peças e acessórios </option>
<option> 2832-1/00 Fabricação de equipamentos para irrigação agrícola, peças e acessórios </option>
<option> 2840-2/00 Fabricação de máquinas-ferramenta, peças e acessórios </option>
<option> 2853-4/00 Fabricação de tratores, peças e acessórios, exceto agrícolas </option>
<option> 2910-7/01 Fabricação de automóveis, camionetas e utilitários </option>
<option> 2910-7/03 Fabricação de motores para automóveis, camionetas e utilitários </option>
<option> 2920-4/01 Fabricação de caminhões e ônibus </option>
<option> 2920-4/02 Fabricação de motores para caminhões e ônibus </option>
<option> 2930-1/01 Fabricação de cabines, carrocerias e reboques para caminhões </option>
<option> 2930-1/02 Fabricação de carrocerias para ônibus </option>
<option> 2949-2/01 Fabricação de bancos e estofados para veículos automotores </option>
<option> 2950-6/00 Recondicionamento e recuperação de motores para veículos automotores </option>
<option> 3011-3/01 Construção de embarcações de grande porte </option>
<option> 3011-3/02 Construção de embarcações para uso comercial e para usos especiais, exceto de grande porte </option>
<option> 3012-1/00 Construção de embarcações para esporte e lazer </option>
<option> 3031-8/00 Fabricação de locomotivas, vagões e outros materiais rodantes </option>
<option> 3032-6/00 Fabricação de peças e acessórios para veículos ferroviários </option>
<option> 3041-5/00 Fabricação de aeronaves </option>
<option> 3050-4/00 Fabricação de veículos militares de combate </option>
<option> 3091-1/01 Fabricação de motocicletas </option>
<option> 3091-1/02 Fabricação de peças e acessórios para motocicletas </option>
<option> 3092-0/00 Fabricação de bicicletas e triciclos não-motorizados, peças e acessórios </option>
<option> 3099-7/00 Fabricação de equipamentos de transporte não especificados anteriormente </option>
<option> 3101-2/00 Fabricação de móveis com predominância de madeira </option>
<option> 3102-1/00 Fabricação de móveis com predominância de metal </option>
<option> 3103-9/00 Fabricação de móveis de outros materiais, exceto madeira e metal </option>
<option> 3104-7/00 Fabricação de colchões </option>
<option> 3211-6/01 Lapidação de gemas </option>
<option> 3211-6/02 Fabricação de artefatos de joalheria e ourivesaria </option>
<option> 3211-6/03 Cunhagem de moedas e medalhas </option>
<option> 3212-4/00 Fabricação de bijuterias e artefatos semelhantes </option>
<option> 3220-5/00 Fabricação de instrumentos musicais, peças e acessórios </option>
<option> 3230-2/00 Fabricação de artefatos para pesca e esporte </option>
<option> 3240-0/01 Fabricação de jogos eletrônicos </option>
<option> 3250-7/05 Fabricação de materiais para medicina e odontologia </option>
<option> 3250-7/06 Serviços de prótese dentária </option>
<option> 3250-7/07 Fabricação de artigos ópticos </option>
<option> 3250-7/09 Serviço de laboratório óptico </option>
<option> 3291-4/00 Fabricação de escovas, pincéis e vassouras </option>
<option> 3292-2/01 Fabricação de roupas de proteção e segurança e resistentes a fogo </option>
<option> 3299-0/01 Fabricação de guarda-chuvas e similares </option>
<option> 3299-0/02 Fabricação de canetas, lápis e outros artigos para escritório </option>
<option> 3299-0/04 Fabricação de painéis e letreiros luminosos </option>
<option> 3299-0/05 Fabricação de aviamentos para costura </option>
<option> 3299-0/06 Fabricação de velas, inclusive decorativas </option>
<option> 3299-0/99 Fabricação de produtos diversos não especificados anteriormente </option>
<option> 3312-1/04 Manutenção e reparação de equipamentos e instrumentos ópticos </option>
<option> 3313-9/01 Manutenção e reparação de geradores, transformadores e motores elétricos </option>
<option> 3314-7/01 Manutenção e reparação de máquinas motrizes não-elétricas </option>
<option> 3314-7/03 Manutenção e reparação de válvulas industriais </option>
<option> 3314-7/04 Manutenção e reparação de compressores </option>
<option> 3314-7/12 Manutenção e reparação de tratores agrícolas </option>
<option> 3314-7/13 Manutenção e reparação de máquinas-ferramenta </option>
<option> 3314-7/16 Manutenção e reparação de tratores, exceto agrícolas </option>
<option> 3315-5/00 Manutenção e reparação de veículos ferroviários </option>
<option> 3316-3/01 Manutenção e reparação de aeronaves, exceto a manutenção na pista </option>
<option> 3316-3/02 Manutenção de aeronaves na pista * </option>
<option> 3317-1/01 Manutenção e reparação de embarcações e estruturas flutuantes </option>
<option> 3317-1/02 Manutenção e reparação de embarcações para esportes e lazer </option>
<option> 3321-0/00 Instalação de máquinas e equipamentos industriais </option>
<option> 3329-5/01 Serviços de montagem de móveis de qualquer material </option>
<option> 3329-5/99 Instalação de outros equipamentos não especificados anteriormente </option>
<option> 3511-5/01 Geração de energia elétrica </option>
<option> 3512-3/00 Transmissão de energia elétrica </option>
<option> 3513-1/00 Comércio atacadista de energia elétrica </option>
<option> 3514-0/00 Distribuição de energia elétrica </option>
<option> 3520-4/01 Produção de gás  processamento de gás natural </option>
<option> 3520-4/02 Distribuição de combustíveis gasosos por redes urbanas </option>
<option> 3530-1/00 Produção e distribuição de vapor, água quente e ar condicionado </option>
<option> 3600-6/01 Captação, tratamento e distribuição de água </option>
<option> 3600-6/02 Distribuição de água por caminhões </option>
<option> 3701-1/00 Gestão de redes de esgoto </option>
<option> 3702-9/00 Atividades relacionadas a esgoto, exceto a gestão de redes </option>
<option> 3811-4/00 Coleta de resíduos não-perigosos </option>
<option> 3812-2/00 Coleta de resíduos perigosos </option>
<option> 3821-1/00 Tratamento e disposição de resíduos não-perigosos </option>
<option> 3822-0/00 Tratamento e disposição de resíduos perigosos </option>
<option> 3831-9/01 Recuperação de sucatas de alumínio </option>
<option> 3831-9/99 Recuperação de materiais metálicos, exceto alumínio </option>
<option> 3832-7/00 Recuperação de materiais plásticos </option>
<option> 3839-4/01 Usinas de compostagem </option>
<option> 3839-4/99 Recuperação de materiais não especificados anteriormente </option>
<option> 3900-5/00 Descontaminação e outros serviços de gestão de resíduos </option>
<option> 4110-7/00 Incorporação de empreendimentos imobiliários </option>
<option> 4120-4/00 Construção de edifícios </option>
<option> 4211-1/01 Construção de rodovias e ferrovias </option>
<option> 4211-1/02 Pintura para sinalização em pistas rodoviárias e aeroportos </option>
<option> 4212-0/00 Construção de obras de arte especiais </option>
<option> 4213-8/00 Obras de urbanização - ruas, praças e calçadas </option>
<option> 4221-9/01 Construção de barragens e represas para geração de energia elétrica </option>
<option> 4221-9/02 Construção de estações e redes de distribuição de energia elétrica </option>
<option> 4221-9/03 Manutenção de redes de distribuição de energia elétrica </option>
<option> 4221-9/04 Construção de estações e redes de telecomunicações </option>
<option> 4221-9/05 Manutenção de estações e redes de telecomunicações </option>
<option> 4222-7/02 Obras de irrigação </option>
<option> 4223-5/00 Construção de redes de transportes por dutos, exceto para água e esgoto </option>
<option> 4291-0/00 Obras portuárias, marítimas e fluviais </option>
<option> 4292-8/01 Montagem de estruturas metálicas </option>
<option> 4292-8/02 Obras de montagem industrial </option>
<option> 4299-5/01 Construção de instalações esportivas e recreativas </option>
<option> 4299-5/99 Outras obras de engenharia civil não especificadas anteriormente </option>
<option> 4311-8/01 Demolição de edifícios e outras estruturas </option>
<option> 4311-8/02 Preparação de canteiro e limpeza de terreno </option>
<option> 4312-6/00 Perfurações e sondagens </option>
<option> 4313-4/00 Obras de terraplenagem </option>
<option> 4319-3/00 Serviços de preparação do terreno não especificados anteriormente </option>
<option> 4321-5/00 Instalação e manutenção elétrica </option>
<option> 4322-3/01 Instalações hidráulicas, sanitárias e de gás </option>
<option> 4322-3/03 Instalações de sistema de prevenção contra incêndio </option>
<option> 4329-1/01 Instalação de painéis publicitários </option>
<option> 4329-1/05 Tratamentos térmicos, acústicos ou de vibração </option>
<option> 4330-4/01 Impermeabilização em obras de engenharia civil </option>
<option> 4330-4/03 Obras de acabamento em gesso e estuque </option>
<option> 4330-4/04 Serviços de pintura de edifícios em geral </option>
<option> 4330-4/05 Aplicação de revestimentos e de resinas em interiores e exteriores </option>
<option> 4330-4/99 Outras obras de acabamento da construção </option>
<option> 4391-6/00 Obras de fundações </option>
<option> 4399-1/01 Administração de obras </option>
<option> 4399-1/02 Montagem e desmontagem de andaimes e outras estruturas temporárias </option>
<option> 4399-1/03 Obras de alvenaria </option>
<option> 4399-1/05 Perfuração e construção de poços de água </option>
<option> 4399-1/99 Serviços especializados para construção não especificados anteriormente </option>
<option> 4511-1/01 Comércio a varejo de automóveis, camionetas e utilitários novos </option>
<option> 4511-1/02 Comércio a varejo de automóveis, camionetas e utilitários usados </option>
<option> 4511-1/04 Comércio por atacado de caminhões novos e usados </option>
<option> 4511-1/05 Comércio por atacado de reboques e semi-reboques novos e usados </option>
<option> 4511-1/06 Comércio por atacado de ônibus e microônibus novos e usados </option>
<option> 4512-9/01 Representantes comerciais e agentes do comércio de veículos automotores </option>
<option> 4512-9/02 Comércio sob consignação de veículos automotores </option>
<option> 4520-0/01 Serviços de manutenção e reparação mecânica de veículos automotores </option>
<option> 4520-0/02 Serviços de lanternagem ou funilaria e pintura de veículos automotores </option>
<option> 4520-0/03 Serviços de manutenção e reparação elétrica de veículos automotores </option>
<option> 4520-0/04 Serviços de alinhamento e balanceamento de veículos automotores </option>
<option> 4520-0/05 Serviços de lavagem, lubrificação e polimento de veículos automotores </option>
<option> 4520-0/06 Serviços de borracharia para veículos automotores </option>
<option> 4520-0/08 Serviços de capotaria </option>
<option> 4530-7/02 Comércio por atacado de pneumáticos e câmaras-de-ar </option>
<option> 4530-7/03 Comércio a varejo de peças e acessórios novos para veículos automotores </option>
<option> 4530-7/04 Comércio a varejo de peças e acessórios usados para veículos automotores </option>
<option> 4530-7/05 Comércio a varejo de pneumáticos e câmaras-de-ar </option>
<option> 4541-2/01 Comércio por atacado de motocicletas e motonetas </option>
<option> 4541-2/02 Comércio por atacado de peças e acessórios para motocicletas e motonetas </option>
<option> 4541-2/03 Comércio a varejo de motocicletas e motonetas novas </option>
<option> 4541-2/04 Comércio a varejo de motocicletas e motonetas usadas </option>
<option> 4541-2/05 Comércio a varejo de peças e acessórios para motocicletas e motonetas </option>
<option> 4542-1/01 Representantes comerciais e agentes do comércio de motocicletas e motonetas, peças e acessórios </option>
<option> 4542-1/02 Comércio sob consignação de motocicletas e motonetas </option>
<option> 4543-9/00 Manutenção e reparação de motocicletas e motonetas </option>
<option> 4621-4/00 Comércio atacadista de café em grão </option>
<option> 4622-2/00 Comércio atacadista de soja </option>
<option> 4623-1/01 Comércio atacadista de animais vivos </option>
<option> 4623-1/03 Comércio atacadista de algodão </option>
<option> 4623-1/04 Comércio atacadista de fumo em folha não beneficiado </option>
<option> 4623-1/05 Comércio atacadista de cacau * </option>
<option> 4623-1/06 Comércio atacadista de sementes, flores, plantas e gramas </option>
<option> 4623-1/07 Comércio atacadista de sisal </option>
<option> 4623-1/09 Comércio atacadista de alimentos para animais </option>
<option> 4631-1/00 Comércio atacadista de leite e laticínios </option>
<option> 4632-0/01 Comércio atacadista de cereais e leguminosas beneficiados </option>
<option> 4632-0/02 Comércio atacadista de farinhas, amidos e féculas </option>
<option> 4633-8/02 Comércio atacadista de aves vivas e ovos </option>
<option> 4634-6/01 Comércio atacadista de carnes bovinas e suínas e derivados </option>
<option> 4634-6/02 Comércio atacadista de aves abatidas e derivados </option>
<option> 4634-6/03 Comércio atacadista de pescados e frutos do mar </option>
<option> 4634-6/99 Comércio atacadista de carnes e derivados de outros animais </option>
<option> 4635-4/01 Comércio atacadista de água mineral </option>
<option> 4635-4/02 Comércio atacadista de cerveja, chope e refrigerante </option>
<option> 4635-4/99 Comércio atacadista de bebidas não especificadas anteriormente </option>
<option> 4636-2/01 Comércio atacadista de fumo beneficiado </option>
<option> 4636-2/02 Comércio atacadista de cigarros, cigarrilhas e charutos </option>
<option> 4637-1/01 Comércio atacadista de café torrado, moído e solúvel </option>
<option> 4637-1/02 Comércio atacadista de açúcar </option>
<option> 4637-1/03 Comércio atacadista de óleos e gorduras </option>
<option> 4637-1/04 Comércio atacadista de pães, bolos, biscoitos e similares </option>
<option> 4637-1/05 Comércio atacadista de massas alimentícias </option>
<option> 4637-1/06 Comércio atacadista de sorvetes </option>
<option> 4639-7/01 Comércio atacadista de produtos alimentícios em geral </option>
<option> 4641-9/01 Comércio atacadista de tecidos </option>
<option> 4641-9/02 Comércio atacadista de artigos de cama, mesa e banho </option>
<option> 4641-9/03 Comércio atacadista de artigos de armarinho </option>
<option> 4643-5/01 Comércio atacadista de calçados </option>
<option> 4643-5/02 Comércio atacadista de bolsas, malas e artigos de viagem </option>
<option> 4644-3/01 Comércio atacadista de medicamentos e drogas de uso humano </option>
<option> 4644-3/02 Comércio atacadista de medicamentos e drogas de uso veterinário </option>
<option> 4645-1/02 Comércio atacadista de próteses e artigos de ortopedia </option>
<option> 4645-1/03 Comércio atacadista de produtos odontológicos </option>
<option> 4646-0/01 Comércio atacadista de cosméticos e produtos de perfumaria </option>
<option> 4646-0/02 Comércio atacadista de produtos de higiene pessoal </option>
<option> 4647-8/01 Comércio atacadista de artigos de escritório e de papelaria </option>
<option> 4647-8/02 Comércio atacadista de livros, jornais e outras publicações </option>
<option> 4649-4/01 Comércio atacadista de equipamentos elétricos de uso pessoal e doméstico </option>
<option> 4649-4/02 Comércio atacadista de aparelhos eletrônicos de uso pessoal e doméstico </option>
<option> 4649-4/03 Comércio atacadista de bicicletas, triciclos e outros veículos recreativos </option>
<option> 4649-4/04 Comércio atacadista de móveis e artigos de colchoaria </option>
<option> 4649-4/05 Comércio atacadista de artigos de tapeçaria  persianas e cortinas </option>
<option> 4649-4/06 Comércio atacadista de lustres, luminárias e abajures </option>
<option> 4649-4/07 Comércio atacadista de filmes, CDs, DVDs, fitas e discos </option>
<option> 4651-6/01 Comércio atacadista de equipamentos de informática </option>
<option> 4651-6/02 Comércio atacadista de suprimentos para informática </option>
<option> 4669-9/01 Comércio atacadista de bombas e compressores  partes e peças </option>
<option> 4671-1/00 Comércio atacadista de madeira e produtos derivados </option>
<option> 4672-9/00 Comércio atacadista de ferragens e ferramentas </option>
<option> 4673-7/00 Comércio atacadista de material elétrico </option>
<option> 4674-5/00 Comércio atacadista de cimento </option>
<option> 4679-6/01 Comércio atacadista de tintas, vernizes e similares </option>
<option> 4679-6/02 Comércio atacadista de mármores e granitos </option>
<option> 4679-6/03 Comércio atacadista de vidros, espelhos e vitrais </option>
<option> 4679-6/99 Comércio atacadista de materiais de construção em geral </option>
<option> 4681-8/02 Comércio atacadista de combustíveis realizado por transportador retalhista (TRR) </option>
<option> 4681-8/04 Comércio atacadista de combustíveis de origem mineral em bruto </option>
<option> 4681-8/05 Comércio atacadista de lubrificantes </option>
<option> 4682-6/00 Comércio atacadista de gás liqüefeito de petróleo (GLP) </option>
<option> 4684-2/01 Comércio atacadista de resinas e elastômeros </option>
<option> 4684-2/02 Comércio atacadista de solventes </option>
<option> 4686-9/01 Comércio atacadista de papel e papelão em bruto </option>
<option> 4686-9/02 Comércio atacadista de embalagens </option>
<option> 4687-7/01 Comércio atacadista de resíduos de papel e papelão </option>
<option> 4687-7/03 Comércio atacadista de resíduos e sucatas metálicos </option>
<option> 4689-3/01 Comércio atacadista de produtos da extração mineral, exceto combustíveis </option>
<option> 4689-3/02 Comércio atacadista de fios e fibras têxteis beneficiados * </option>
<option> 4713-0/01 Lojas de departamentos ou magazines </option>
<option> 4713-0/02 Lojas de variedades, exceto lojas de departamentos ou magazines </option>
<option> 4713-0/03 Lojas duty free de aeroportos internacionais </option>
<option> 4721-1/02 Padaria e confeitaria com predominância de revenda </option>
<option> 4721-1/03 Comércio varejista de laticínios e frios </option>
<option> 4721-1/04 Comércio varejista de doces, balas, bombons e semelhantes </option>
<option> 4722-9/01 Comércio varejista de carnes - açougues </option>
<option> 4722-9/02 Peixaria </option>
<option> 4723-7/00 Comércio varejista de bebidas </option>
<option> 4724-5/00 Comércio varejista de hortifrutigranjeiros </option>
<option> 4729-6/01 Tabacaria </option>
<option> 4729-6/02 Comércio varejista de mercadorias em lojas de conveniência </option>
<option> 4731-8/00 Comércio varejista de combustíveis para veículos automotores </option>
<option> 4732-6/00 Comércio varejista de lubrificantes </option>
<option> 4741-5/00 Comércio varejista de tintas e materiais para pintura </option>
<option> 4742-3/00 Comércio varejista de material elétrico </option>
<option> 4743-1/00 Comércio varejista de vidros </option>
<option> 4744-0/01 Comércio varejista de ferragens e ferramentas </option>
<option> 4744-0/02 Comércio varejista de madeira e artefatos </option>
<option> 4744-0/03 Comércio varejista de materiais hidráulicos </option>
<option> 4744-0/04 Comércio varejista de cal, areia, pedra britada, tijolos e telhas </option>
<option> 4744-0/06 Comércio varejista de pedras para revestimento </option>
<option> 4744-0/99 Comércio varejista de materiais de construção em geral </option>
<option> 4751-2/02 Recarga de cartuchos para equipamentos de informática </option>
<option> 4754-7/01 Comércio varejista de móveis </option>
<option> 4754-7/02 Comércio varejista de artigos de colchoaria </option>
<option> 4754-7/03 Comércio varejista de artigos de iluminação </option>
<option> 4755-5/01 Comércio varejista de tecidos </option>
<option> 4755-5/02 Comercio varejista de artigos de armarinho </option>
<option> 4755-5/03 Comercio varejista de artigos de cama, mesa e banho </option>
<option> 4756-3/00 Comércio varejista especializado de instrumentos musicais e acessórios </option>
<option> 4759-8/01 Comércio varejista de artigos de tapeçaria, cortinas e persianas </option>
<option> 4759-8/99 Comércio varejista de outros artigos de uso doméstico não especificados anteriormente </option>
<option> 4761-0/01 Comércio varejista de livros </option>
<option> 4761-0/02 Comércio varejista de jornais e revistas </option>
<option> 4761-0/03 Comércio varejista de artigos de papelaria </option>
<option> 4762-8/00 Comércio varejista de discos, CDs, DVDs e fitas </option>
<option> 4763-6/01 Comércio varejista de brinquedos e artigos recreativos </option>
<option> 4763-6/02 Comércio varejista de artigos esportivos </option>
<option> 4763-6/03 Comércio varejista de bicicletas e triciclos  peças e acessórios </option>
<option> 4763-6/04 Comércio varejista de artigos de caça, pesca e camping </option>
<option> 4771-7/02 Comércio varejista de produtos farmacêuticos, com manipulação de fórmulas </option>
<option> 4771-7/03 Comércio varejista de produtos farmacêuticos homeopáticos </option>
<option> 4771-7/04 Comércio varejista de medicamentos veterinários </option>
<option> 4773-3/00 Comércio varejista de artigos médicos e ortopédicos </option>
<option> 4774-1/00 Comércio varejista de artigos de óptica </option>
<option> 4781-4/00 Comércio varejista de artigos do vestuário e acessórios </option>
<option> 4782-2/01 Comércio varejista de calçados </option>
<option> 4782-2/02 Comércio varejista de artigos de viagem </option>
<option> 4783-1/01 Comércio varejista de artigos de joalheria </option>
<option> 4783-1/02 Comércio varejista de artigos de relojoaria </option>
<option> 4784-9/00 Comércio varejista de gás liqüefeito de petróleo (GLP) </option>
<option> 4785-7/01 Comércio varejista de antigüidades </option>
<option> 4785-7/99 Comércio varejista de outros artigos usados </option>
<option> 4789-0/01 Comércio varejista de suvenires, bijuterias e artesanatos </option>
<option> 4789-0/02 Comércio varejista de plantas e flores naturais </option>
<option> 4789-0/03 Comércio varejista de objetos de arte </option>
<option> 4789-0/05 Comércio varejista de produtos saneantes domissanitários </option>
<option> 4789-0/06 Comércio varejista de fogos de artifício e artigos pirotécnicos </option>
<option> 4789-0/07 Comércio varejista de equipamentos para escritório </option>
<option> 4789-0/08 Comércio varejista de artigos fotográficos e para filmagem </option>
<option> 4789-0/09 Comércio varejista de armas e munições </option>
<option> 4789-0/99 Comércio varejista de outros produtos não especificados anteriormente </option>
<option> 4911-6/00 Transporte ferroviário de carga </option>
<option> 4912-4/01 Transporte ferroviário de passageiros intermunicipal e interestadual </option>
<option> 4912-4/02 Transporte ferroviário de passageiros municipal e em região metropolitana </option>
<option> 4912-4/03 Transporte metroviário </option>
<option> 4923-0/01 Serviço de táxi </option>
<option> 4923-0/02 Serviço de transporte de passageiros - locação de automóveis com motorista </option>
<option> 4924-8/00 Transporte escolar </option>
<option> 4929-9/03 Organização de excursões em veículos rodoviários próprios, municipal </option>
<option> 4929-9/04 Organização de excursões em veículos rodoviários próprios, intermunicipal, interestadual e internacional </option>
<option> 4930-2/03 Transporte rodoviário de produtos perigosos </option>
<option> 4930-2/04 Transporte rodoviário de mudanças </option>
<option> 4940-0/00 Transporte dutoviário </option>
<option> 4950-7/00 Trens turísticos, teleféricos e similares </option>
<option> 5011-4/01 Transporte marítimo de cabotagem - Carga </option>
<option> 5011-4/02 Transporte marítimo de cabotagem - passageiros </option>
<option> 5012-2/01 Transporte marítimo de longo curso - Carga </option>
<option> 5012-2/02 Transporte marítimo de longo curso - Passageiros </option>
<option> 5021-1/01 Transporte por navegação interior de carga, municipal, exceto travessia </option>
<option> 5021-1/02 Transporte por navegação interior de carga, intermunicipal, interestadual e internacional, exceto travessia </option>
<option> 5030-1/01 Navegação de apoio marítimo </option>
<option> 5030-1/02 Navegação de apoio portuário </option>
<option> 5030-1/03 Serviços de rebocadores e empurradores </option>
<option> 5091-2/01 Transporte por navegação de travessia, municipal </option>
<option> 5099-8/01 Transporte aquaviário para passeios turísticos </option>
<option> 5099-8/99 Outros transportes aquaviários não especificados anteriormente </option>
<option> 5111-1/00 Transporte aéreo de passageiros regular </option>
<option> 5112-9/01 Serviço de táxi aéreo e locação de aeronaves com tripulação </option>
<option> 5112-9/99 Outros serviços de transporte aéreo de passageiros não-regular </option>
<option> 5120-0/00 Transporte aéreo de carga </option>
<option> 5130-7/00 Transporte espacial </option>
<option> 5211-7/01 Armazéns gerais - emissão de warrant </option>
<option> 5211-7/02 Guarda-móveis </option>
<option> 5212-5/00 Carga e descarga </option>
<option> 5221-4/00 Concessionárias de rodovias, pontes, túneis e serviços relacionados </option>
<option> 5222-2/00 Terminais rodoviários e ferroviários </option>
<option> 5223-1/00 Estacionamento de veículos </option>
<option> 5229-0/01 Serviços de apoio ao transporte por táxi, inclusive centrais de chamada </option>
<option> 5229-0/02 Serviços de reboque de veículos </option>
<option> 5229-0/99 Outras atividades auxiliares dos transportes terrestres não especificadas anteriormente </option>
<option> 5231-1/01 Administração da infra-estrutura portuária </option>
<option> 5231-1/02 Atividades do Operador portuário </option>
<option> 5232-0/00 Atividades de agenciamento marítimo </option>
<option> 5239-7/01 Serviços de praticagem </option>
<option> 5239-7/99 Atividades auxiliares dos transportes aquaviários não especificadas anteriormente </option>
<option> 5240-1/01 Operação dos aeroportos e campos de aterrissagem </option>
<option> 5250-8/01 Comissaria de despachos </option>
<option> 5250-8/02 Atividades de despachantes aduaneiros </option>
<option> 5250-8/03 Agenciamento de cargas, exceto para o transporte marítimo </option>
<option> 5250-8/04 Organização logística do transporte de carga </option>
<option> 5250-8/05 Operador de transporte multimodal - OTM </option>
<option> 5310-5/01 Atividades do Correio Nacional </option>
<option> 5310-5/02 Atividades de franqueadas e permissionárias do Correio Nacional </option>
<option> 5320-2/01 Serviços de malote não realizados pelo Correio Nacional </option>
<option> 5320-2/02 Serviços de entrega rápida </option>
<option> 5510-8/01 Hotéis </option>
<option> 5510-8/02 Apart-hotéis </option>
<option> 5510-8/03 Motéis </option>
<option> 5590-6/01 Albergues, exceto assistenciais </option>
<option> 5590-6/02 Campings </option>
<option> 5590-6/03 Pensões </option>
<option> 5590-6/99 Outros alojamentos não especificados anteriormente </option>
<option> 5611-2/01 Restaurantes e similares </option>
<option> 5611-2/02 Bares e outros estabelecimentos especializados em servir bebidas </option>
<option> 5611-2/03 Lanchonetes, casas de chá, de sucos e similares </option>
<option> 5612-1/00 Serviços ambulantes de alimentação </option>
<option> 5620-1/01 Fornecimento de alimentos preparados preponderantemente para empresas </option>
<option> 5620-1/02 Serviços de alimentação para eventos e recepções - bufê </option>
<option> 5620-1/03 Cantinas - serviços de alimentação privativos </option>
<option> 5620-1/04 Fornecimento de alimentos preparados preponderantemente para consumo domiciliar </option>
<option> 5811-5/00 Edição de livros </option>
<option> 5812-3/01 Edição de jornais diários </option>
<option> 5812-3/02 Edição de jornais não diários </option>
<option> 5813-1/00 Edição de revistas </option>
<option> 5819-1/00 Edição de cadastros, listas e de outros produtos gráficos </option>
<option> 5821-2/00 Edição integrada à impressão de livros </option>
<option> 5822-1/01 Edição integrada a impressão de jornais diários </option>
<option> 5822-1/02 Edição integrada a impressão de jornais não diários </option>
<option> 5823-9/00 Edição integrada à impressão de revistas </option>
<option> 5829-8/00 Edição integrada à impressão de cadastros, listas e de outros produtos gráficos </option>
<option> 5911-1/01 Estúdios cinematográficos </option>
<option> 5911-1/02 Produção de filmes para publicidade </option>
<option> 5912-0/01 Serviços de dublagem </option>
<option> 5912-0/02 Serviços de mixagem sonora </option>
<option> 5913-8/00 Distribuição cinematográfica, de vídeo e de programas de televisão </option>
<option> 5914-6/00 Atividades de exibição cinematográfica </option>
<option> 5920-1/00 Atividades de gravação de som e de edição de música </option>
<option> 6010-1/00 Atividades de rádio e televisão </option>
<option> 6021-7/00 Atividades de televisão aberta </option>
<option> 6022-5/01 Programadoras </option>
<option> 6022-5/02 Atividades relacionadas à televisão por assinatura, exceto programadoras </option>
<option> 6110-8/01 Serviços de telefonia fixa comutada - STFC </option>
<option> 6110-8/02 Serviços de redes de transportes de telecomunicações - SRTT </option>
<option> 6110-8/03 Serviços de comunicação multimídia - SMC </option>
<option> 6110-8/99 Serviços de telecomunicações por fio não especificados anteriormente </option>
<option> 6120-5/01 Telefonia móvel celular </option>
<option> 6120-5/02 Serviço móvel especializado - SME </option>
<option> 6120-5/99 Serviços de telecomunicações sem fio não especificados anteriormente </option>
<option> 6130-2/00 Telecomunicações por satélite </option>
<option> 6141-8/00 Operadoras de televisão por assinatura por cabo </option>
<option> 6142-6/00 Operadoras de televisão por assinatura por microondas </option>
<option> 6143-4/00 Operadoras de televisão por assinatura por satélite </option>
<option> 6190-6/01 Provedores de acesso às redes de comunicações </option>
<option> 6190-6/02 Provedores de voz sobre protocolo internet - VOIP </option>
<option> 6190-6/99 Outras atividades de telecomunicações não especificadas anteriormente </option>
<option> 6201-5/01 Desenvolvimento de programas de computador sob encomenda </option>
<option> 6201-5/02 Web design </option>
<option> 6202-3/00 Desenvolvimento e licenciamento de programas de computador customizáveis </option>
<option> 6203-1/00 Desenvolvimento e licenciamento de programas de computador não-customizáveis </option>
<option> 6204-0/00 Consultoria em tecnologia da informação </option>
<option> 6209-1/00 Suporte técnico, manutenção e outros serviços em tecnologia da informação </option>
<option> 6311-9/00 Tratamento de dados, provedores de serviços de aplicação e serviços de hospedagem na internet </option>
<option> 6319-4/00 Portais, provedores de conteúdo e outros serviços de informação na internet </option>
<option> 6391-7/00 Agências de notícias </option>
<option> 6399-2/00 Outras atividades de prestação de serviços de informação não especificadas anteriormente </option>
<option> 6410-7/00 Banco Central </option>
<option> 6421-2/00 Bancos comerciais </option>
<option> 6422-1/00 Bancos múltiplos, com carteira comercial </option>
<option> 6423-9/00 Caixas econômicas </option>
<option> 6424-7/01 Bancos cooperativos </option>
<option> 6424-7/02 Cooperativas centrais de crédito </option>
<option> 6424-7/03 Cooperativas de crédito mútuo </option>
<option> 6424-7/04 Cooperativas de crédito rural </option>
<option> 6431-0/00 Bancos múltiplos, sem carteira comercial </option>
<option> 6432-8/00 Bancos de investimento </option>
<option> 6433-6/00 Bancos de desenvolvimento </option>
<option> 6434-4/00 Agências de fomento </option>
<option> 6435-2/01 Sociedades de crédito imobiliário </option>
<option> 6435-2/02 Associações de poupança e empréstimo </option>
<option> 6435-2/03 Companhias hipotecárias </option>
<option> 6436-1/00 Sociedades de crédito, financiamento e investimento - financeiras </option>
<option> 6437-9/00 Sociedades de crédito ao microempreendedor </option>
<option> 6438-7/01 Bancos de câmbio </option>
<option> 6438-7/02 Outra instituições de intermediação não-monetária não especificadas anteriormente </option>
<option> 6440-9/00 Arrendamento mercantil </option>
<option> 6450-6/00 Sociedades de capitalização </option>
<option> 6461-1/00 Holdings de instituições financeiras </option>
<option> 6462-0/00 Holdings de instituições não-financeiras </option>
<option> 6463-8/00 Outras sociedades de participação, exceto holdings </option>
<option> 6470-1/01 Fundos de investimento, exceto previdenciários e imobiliários </option>
<option> 6470-1/02 Fundos de investimento previdenciários </option>
<option> 6470-1/03 Fundos de investimento imobiliários </option>
<option> 6491-3/00 Sociedades de fomento mercantil - factoring </option>
<option> 6492-1/00 Securitização de créditos </option>
<option> 6493-0/00 Administração de consórcios para aquisição de bens e direitos </option>
<option> 6499-9/01 Clubes de investimento </option>
<option> 6499-9/02 Sociedades de investimento </option>
<option> 6499-9/03 Fundo garantidor de crédito </option>
<option> 6499-9/04 Caixas de financiamento de corporações </option>
<option> 6499-9/05 Concessão de crédito pelas OSCIP </option>
<option> 6499-9/99 Outras atividades de serviços financeiros não especificadas anteriormente </option>
<option> 6511-1/01 Sociedade seguradora de seguros vida </option>
<option> 6511-1/02 Planos de auxílio-funeral </option>
<option> 6512-0/00 Sociedade seguradora de seguros não vida </option>
<option> 6520-1/00 Sociedade seguradora de seguros saúde </option>
<option> 6530-8/00 Resseguros </option>
<option> 6541-3/00 Previdência complementar fechada </option>
<option> 6542-1/00 Previdência complementar aberta </option>
<option> 6550-2/00 Planos de saúde </option>
<option> 6611-8/01 Bolsa de valores </option>
<option> 6611-8/02 Bolsa de mercadorias </option>
<option> 6611-8/03 Bolsa de mercadorias e futuros </option>
<option> 6611-8/04 Administração de mercados de balcão organizados </option>
<option> 6612-6/01 Corretoras de títulos e valores mobiliários </option>
<option> 6612-6/02 Distribuidoras de títulos e valores mobiliários </option>
<option> 6612-6/03 Corretoras de câmbio </option>
<option> 6612-6/04 Corretoras de contratos de mercadorias </option>
<option> 6612-6/05 Agentes de investimentos em aplicações financeiras </option>
<option> 6613-4/00 Administração de cartões de crédito </option>
<option> 6619-3/01 Serviços de liquidação e custódia </option>
<option> 6619-3/02 Correspondentes de instituições financeiras </option>
<option> 6619-3/03 Representações de bancos estrangeiros </option>
<option> 6619-3/04 Caixas eletrônicos </option>
<option> 6619-3/05 Operadoras de cartões de débito </option>
<option> 6621-5/01 Peritos e avaliadores de seguros </option>
<option> 6621-5/02 Auditoria e consultoria atuarial </option>
<option> 6630-4/00 Atividades de administração de fundos por contrato ou comissão </option>
<option> 6810-2/01 Compra e venda de imóveis próprios </option>
<option> 6810-2/02 Aluguel de imóveis próprios </option>
<option> 6810-2/03 Loteamento de imóveis próprios </option>
<option> 6821-8/01 Corretagem na compra e venda e avaliação de imóveis </option>
<option> 6821-8/02 Corretagem no aluguel de imóveis </option>
<option> 6822-6/00 Gestão e administração da propriedade imobiliária* </option>
<option> 6911-7/01 Serviços advocatícios </option>
<option> 6911-7/02 Atividades auxiliares da justiça </option>
<option> 6911-7/03 Agente de propriedade industrial </option>
<option> 6912-5/00 Cartórios </option>
<option> 6920-6/01 Atividades de contabilidade </option>
<option> 6920-6/02 Atividades de consultoria e auditoria contábil e tributária </option>
<option> 7111-1/00 Serviços de arquitetura </option>
<option> 7112-0/00 Serviços de engenharia </option>
<option> 7119-7/01 Serviços de cartografia, topografia e geodésia </option>
<option> 7119-7/02 Atividades de estudos geológicos </option>
<option> 7119-7/03 Serviços de desenho técnico relacionados à arquitetura e engenharia </option>
<option> 7119-7/04 Serviços de perícia técnica relacionados à segurança do trabalho </option>
<option> 7120-1/00 Testes e análises técnicas </option>
<option> 7210-0/00 Pesquisa e desenvolvimento experimental em ciências físicas e naturais </option>
<option> 7220-7/00 Pesquisa e desenvolvimento experimental em ciências sociais e humanas </option>
<option> 7311-4/00 Agências de publicidade </option>
<option> 7319-0/01 Criação e montagem de estandes para feiras e exposições </option>
<option> 7319-0/02 Promoção de vendas </option>
<option> 7319-0/03 Marketing direto </option>
<option> 7319-0/04 Consultoria em publicidade </option>
<option> 7319-0/99 Outras atividades de publicidade não especificadas anteriormente </option>
<option> 7320-3/00 Pesquisas de mercado e de opinião pública </option>
<option> 7410-2/03 Design de produto </option>
<option> 7410-2/99 Atividades de design não especificadas anteriormente </option>
<option> 7410-2/02 Design de interiores </option>
<option> 7420-0/01 Atividades de produção de fotografias, exceto aérea e submarina </option>
<option> 7420-0/02 Atividades de produção de fotografias aéreas e submarinas </option>
<option> 7420-0/03 Laboratórios fotográficos </option>
<option> 7420-0/04 Filmagem de festas e eventos </option>
<option> 7420-0/05 Serviços de microfilmagem </option>
<option> 7490-1/01 Serviços de tradução, interpretação e similares </option>
<option> 7490-1/02 Escafandria e mergulho </option>
<option> 7500-1/00 Atividades veterinárias </option>
<option> 7711-0/00 Locação de automóveis sem condutor </option>
<option> 7719-5/01 Locação de embarcações sem tripulação, exceto para fins recreativos </option>
<option> 7719-5/02 Locação de aeronaves sem tripulação </option>
<option> 7721-7/00 Aluguel de equipamentos recreativos e esportivos </option>
<option> 7722-5/00 Aluguel de fitas de vídeo, DVDs e similares </option>
<option> 7723-3/00 Aluguel de objetos do vestuário, jóias e acessórios </option>
<option> 7729-2/01 Aluguel de aparelhos de jogos eletrônicos </option>
<option> 7729-2/03 Aluguel de material médico* </option>
<option> 7731-4/00 Aluguel de máquinas e equipamentos agrícolas sem operador </option>
<option> 7732-2/02 Aluguel de andaimes </option>
<option> 7733-1/00 Aluguel de máquinas e equipamentos para escritórios </option>
<option> 7739-0/02 Aluguel de equipamentos científicos, médicos e hospitalares, sem operador </option>
<option> 7740-3/00 Gestão de ativos intangíveis não-financeiros </option>
<option> 7810-8/00 Seleção e agenciamento de mão-de-obra </option>
<option> 7820-5/00 Locação de mão-de-obra temporária </option>
<option> 7830-2/00 Fornecimento e gestão de recursos humanos para terceiros </option>
<option> 7911-2/00 Agências de viagens </option>
<option> 7912-1/00 Operadores turísticos </option>
<option> 8011-1/01 Atividades de vigilância e segurança privada </option>
<option> 8011-1/02 Serviços de adestramento de cães de guarda </option>
<option> 8012-9/00 Atividades de transporte de valores </option>
<option> 8020-0/01 Atividades de monitoramento de sistemas de segurança eletrônico </option>
<option> 8020-0/02 Outras atividades de serviços de segurança </option>
<option> 8030-7/00 Atividades de investigação particular </option>
<option> 8111-7/00 Serviços combinados para apoio a edifícios, exceto condomínios prediais </option>
<option> 8112-5/00 Condomínios prediais </option>
<option> 8121-4/00 Limpeza em prédios e em domicílios </option>
<option> 8122-2/00 Imunização e controle de pragas urbanas </option>
<option> 8129-0/00 Atividades de limpeza não especificadas anteriormente </option>
<option> 8130-3/00 Atividades paisagísticas </option>
<option> 8211-3/00 Serviços combinados de escritório e apoio administrativo </option>
<option> 8219-9/01 Fotocópias </option>
<option> 8220-2/00 Atividades de teleatendimento </option>
<option> 8230-0/01 Serviços de organização de feiras, congressos, exposições e festas </option>
<option> 8230-0/02 Casas de festas e eventos </option>
<option> 8291-1/00 Atividades de cobranças e informações cadastrais </option>
<option> 8292-0/00 Envasamento e empacotamento sob contrato </option>
<option> 8299-7/01 Medição de consumo de energia elétrica, gás e água </option>
<option> 8299-7/02 Emissão de vales-alimentação, vales-transporte e similares </option>
<option> 8299-7/03 Serviços de gravação de carimbos, exceto confecção </option>
<option> 8299-7/04 Leiloeiros independentes </option>
<option> 8299-7/05 Serviços de levantamento de fundos sob contrato </option>
<option> 8299-7/06 Casas lotéricas </option>
<option> 8299-7/07 Salas de acesso à internet </option>
<option> 8411-6/00 Administração pública em geral </option>
<option> 8413-2/00 Regulação das atividades econômicas </option>
<option> 8421-3/00 Relações exteriores </option>
<option> 8422-1/00 Defesa </option>
<option> 8423-0/00 Justiça </option>
<option> 8424-8/00 Segurança e ordem pública </option>
<option> 8425-6/00 Defesa Civil </option>
<option> 8430-2/00 Seguridade social obrigatória </option>
<option> 8511-2/00 Educação infantil - creche </option>
<option> 8512-1/00 Educação infantil - pré-escola </option>
<option> 8513-9/00 Ensino fundamental </option>
<option> 8520-1/00 Ensino médio </option>
<option> 8531-7/00 Educação superior - graduação </option>
<option> 8532-5/00 Educação superior - graduação e pós-graduação </option>
<option> 8533-3/00 Educação superior - pós-graduação e extensão </option>
<option> 8541-4/00 Educação profissional de nível técnico </option>
<option> 8542-2/00 Educação profissional de nível tecnológico </option>
<option> 8550-3/01 Administração de caixas escolares </option>
<option> 8550-3/02 Serviços auxiliares à educação </option>
<option> 8591-1/00 Ensino de esportes </option>
<option> 8592-9/01 Ensino de dança </option>
<option> 8592-9/02 Ensino de artes cênicas, exceto dança </option>
<option> 8592-9/03 Ensino de música </option>
<option> 8592-9/99 Ensino de arte e cultura não especificado anteriormente </option>
<option> 8593-7/00 Ensino de idiomas </option>
<option> 8599-6/01 Formação de condutores </option>
<option> 8599-6/02 Cursos de pilotagem </option>
<option> 8599-6/03 Treinamento em informática </option>
<option> 8599-6/04 Treinamento em desenvolvimento profissional e gerencial </option>
<option> 8599-6/05 Cursos preparatórios para concursos </option>
<option> 8599-6/99 Outras atividades de ensino não especificadas anteriormente </option>
<option> 8621-6/01 UTI móvel </option>
<option> 8621-6/02 Serviços móveis de atendimento a urgências, exceto por UTI móvel </option>
<option> 8630-5/03 Atividade médica ambulatorial restrita a consultas </option>
<option> 8630-5/04 Atividade odontológica </option>
<option> 8630-5/06 Serviços de vacinação e imunização humana </option>
<option> 8630-5/07 Atividades de reprodução humana assistida </option>
<option> 8630-5/99 Atividades de atenção ambulatorial não especificadas anteriormente </option>
<option> 8640-2/01 Laboratórios de anatomia patológica e citológica </option>
<option> 8640-2/02 Laboratórios clínicos </option>
<option> 8640-2/03 Serviços de diálise e nefrologia </option>
<option> 8640-2/04 Serviços de tomografia </option>
<option> 8640-2/06 Serviços de ressonância magnética </option>
<option> 8640-2/10 Serviços de quimioterapia </option>
<option> 8640-2/11 Serviços de radioterapia </option>
<option> 8640-2/12 Serviços de hemoterapia </option>
<option> 8640-2/13 Serviços de litotripsia </option>
<option> 8640-2/14 Serviços de bancos de células e tecidos humanos </option>
<option> 8650-0/01 Atividades de enfermagem </option>
<option> 8650-0/02 Atividades de profissionais da nutrição </option>
<option> 8650-0/03 Atividades de psicologia e psicanálise </option>
<option> 8650-0/04 Atividades de fisioterapia </option>
<option> 8650-0/05 Atividades de terapia ocupacional </option>
<option> 8650-0/06 Atividades de fonoaudiologia </option>
<option> 8650-0/07 Atividades de terapia de nutrição enteral e parenteral </option>
<option> 8660-7/00 Atividades de apoio à gestão de saúde </option>
<option> 8690-9/01 Atividades de práticas integrativas e complementares em saúde humana </option>
<option> 8690-9/02 Atividades de banco de leite humano </option>
<option> 8690-9/03 Atividades de acupuntura </option>
<option> 8690-9/04 Atividades de podologia </option>
<option> 8711-5/01 Clínicas e residências geriátricas </option>
<option> 8711-5/02 Instituições de longa permanência para idosos </option>
<option> 8711-5/04 Centros de apoio a pacientes com câncer e com AIDS </option>
<option> 8711-5/05 Condomínios residenciais para idosos </option>
<option> 8720-4/01 Atividades de centros de assistência psicossocial </option>
<option> 8730-1/01 Orfanatos </option>
<option> 8730-1/02 Albergues assistenciais </option>
<option> 8800-6/00 Serviços de assistência social sem alojamento </option>
<option> 9001-9/01 Produção teatral </option>
<option> 9001-9/02 Produção musical </option>
<option> 9001-9/03 Produção de espetáculos de dança </option>
<option> 9001-9/04 Produção de espetáculos circenses, de marionetes e similares </option>
<option> 9001-9/05 Produção de espetáculos de rodeios, vaquejadas e similares </option>
<option> 9001-9/06 Atividades de sonorização e de iluminação </option>
<option> 9002-7/01 Atividades de artistas plásticos, jornalistas independentes e escritores </option>
<option> 9002-7/02 Restauração de obras-de-arte </option>
<option> 9101-5/00 Atividades de bibliotecas e arquivos </option>
<option> 9102-3/02 Restauração e conservação de lugares e prédios históricos </option>
<option> 9200-3/01 Casas de bingo </option>
<option> 9200-3/02 Exploração de apostas em corridas de cavalos </option>
<option> 9200-3/99 Exploração de jogos de azar e apostas não especificados anteriormente </option>
<option> 9311-5/00 Gestão de instalações de esportes </option>
<option> 9312-3/00 Clubes sociais, esportivos e similares </option>
<option> 9313-1/00 Atividades de condicionamento físico </option>
<option> 9319-1/01 Produção e promoção de eventos esportivos </option>
<option> 9319-1/99 Outras atividades esportivas não especificadas anteriormente </option>
<option> 9321-2/00 Parques de diversão e parques temáticos </option>
<option> 9329-8/01 Discotecas, danceterias, salões de dança e similares </option>
<option> 9329-8/02 Exploração de boliches </option>
<option> 9329-8/03 Exploração de jogos de sinuca, bilhar e similares </option>
<option> 9329-8/04 Exploração de jogos eletrônicos recreativos </option>
<option> 9329-8/99 Outras atividades de recreação e lazer não especificadas anteriormente </option>
<option> 9411-1/00 Atividades de organizações associativas patronais e empresariais </option>
<option> 9412-0/01 Atividades de fiscalização profissional </option>
<option> 9412-0/99 Outras Atividades associativas profissionais </option>
<option> 9420-1/00 Atividades de organizações sindicais </option>
<option> 9430-8/00 Atividades de associações de defesa de direitos sociais </option>
<option> 9491-0/00 Atividades de organizações religiosas ou filosóficas </option>
<option> 9492-8/00 Atividades de organizações políticas </option>
<option> 9493-6/00 Atividades de organizações associativas ligadas à cultura e à arte </option>
<option> 9499-5/00 Atividades associativas não especificadas anteriormente </option>
<option> 9511-8/00 Reparação e manutenção de computadores e de equipamentos periféricos </option>
<option> 9512-6/00 Reparação e manutenção de equipamentos de comunicação </option>
<option> 9521-5/00 Reparação e manutenção de equipamentos eletroeletrônicos de uso pessoal e doméstico </option>
<option> 9529-1/01 Reparação de calçados, de bolsas e artigos de viagem* </option>
<option> 9529-1/02 Chaveiros </option>
<option> 9529-1/03 Reparação de relógios </option>
<option> 9529-1/04 Reparação de bicicletas, triciclos e outros veículos não-motorizados </option>
<option> 9529-1/05 Reparação de artigos do mobiliário </option>
<option> 9529-1/06 Reparação de jóias </option>
<option> 9601-7/01 Lavanderias </option>
<option> 9601-7/02 Tinturarias </option>
<option> 9601-7/03 Toalheiros </option>
<option> 9602-5/01 Cabeleireiros, manicure e pedicure </option>
<option> 9602-5/02 Atividades de estética e outros serviços de cuidados com a beleza </option>
<option> 9603-3/01 Gestão e manutenção de cemitérios </option>
<option> 9603-3/02 Serviços de cremação </option>
<option> 9603-3/03 Serviços de sepultamento </option>
<option> 9603-3/04 Serviços de funerárias </option>
<option> 9603-3/05 Serviços de somatoconservação </option>
<option> 9609-2/02 Agências matrimoniais </option>
<option> 9609-2/07 Alojamento de animais domésticos </option>
<option> 9609-2/08 Higiene e embelezamento de animais domésticos </option>
<option> 9609-2/04 Exploração de máquinas de serviços pessoais acionadas por moeda </option>
<option> 9609-2/05 Atividades de sauna e banhos </option>
<option> 9609-2/06 Serviços de tatuagem e colocação de piercing </option>
<option> 9609-2/99 Outras atividades de serviços pessoais não especificadas anteriormente </option>
<option> 9700-5/00 Serviços domésticos </option>
<option> 9900-8/00 Organismos internacionais e outras instituições extraterritoriais </option>

                        </FormSelect>
                </div>
                <div className="form-section">
                    <h3 className="form-section-title">Endereço contábil</h3>
                    <div className="form-section-row">

                        <FormInput id="cep" label={"CEP"}
                            colStyle={{ flexBasis: "0.07%", minWidth: '120px' }}
                            endIcon={Search}
                            validators={[
                                { func: cepValidator, argument: 8 }
                            ]}
                            mask={
                                cepMask
                            }
                            updateField={updateField}
                        />

                        <FormInput id="endereco" label={"Endereço"}
                            colStyle={{ flexBasis: "26.5%" }}
                            validators={[
                                { func: sizeValidator, argument: 1 }
                            ]}
                            updateField={updateField}
                        />

                        <FormInput id="numero" label={"Nº"}
                            colStyle={{ flexBasis: "0.04%", minWidth: '50px' }}
                            validators={[
                                { func: sizeValidator, argument: 1 }
                            ]}
                            mask={
                                numberMask
                            }
                            updateField={updateField}
                        />

                        <FormInput id="complemento" label={"Complemento"} colStyle={{ flexBasis: "13.4%", minWidth: '150px' }} updateField={updateField} />
                    </div>

                    <div className="form-section-row">
                        <FormInput id="bairro" label={"Bairro"}
                            validators={[
                                { func: sizeValidator, argument: 1 }
                            ]}
                            mask={
                                letraMask
                            }
                            updateField={updateField}
                        />

                        <FormInput id="uf" label={"Estado/UF"}
                            validators={[
                                { func: sizeValidator, argument: 1 }
                            ]}
                            mask={
                                letraMask
                            }
                            updateField={updateField}
                        />

                        <FormInput id="cidade" label={"Cidade"}
                            validators={[
                                { func: sizeValidator, argument: 1 }
                            ]}
                            mask={
                                letraMask
                            }
                            updateField={updateField}
                        />
                    </div>

                </div>
                <div className="form-section">
                    <h3 className="form-section-title">Responsável pela conta na Cobalt</h3>
                    <div className="form-section-row">
                        <FormInput id="nomecompleto" label={"Nome completo"}
                            validators={[
                                { func: sizeValidator, argument: 1 }
                            ]}
                            updateField={updateField}
                        />
                        <FormInput id="cargo" label={"Cargo"}
                            validators={[
                                { func: sizeValidator, argument: 1 }
                            ]}
                            updateField={updateField}
                        />
                    </div>

                    <div className="form-section-row">
                        <FormInput id="celular" label={"Celular"}
                            validators={[
                                { func: sizeValidator, argument: 11 }
                            ]}
                            mask={
                                cellMask
                            }
                            placeholder="(XX) XXXXX-XXXX"
                            updateField={updateField}
                        />

                        <FormInput id="telefonecomercial" label={"Telefone Comercial"}
                            validators={[
                                { func: sizeValidator, argument: 10 }
                            ]}
                            mask={
                                phoneMask
                            }
                            placeholder="(XX) XXXX-XXXX"
                            updateField={updateField}
                        />

                        <FormInput id="email" label={"E-mail"} colStyle={{ flexBasis: "25%" }}
                            onBlur={(e) => {validationSearchParams(true,e)}}
                            validators={[
                                { func: mailValidator, argument: 1 }
                            ]}
                            updateField={updateField}
                        />

                    </div>

                    <div className="form-section-row">
                        <FormInput id="siteempresa" label={"Site da empresa"}
                            validators={[
                                { func: sizeValidator, argument: 1 }
                            ]}
                            updateField={updateField}
                        />
                    </div>


                </div>
            </div>


            <div className='conta-content-footer'>
                <div className='divider'></div>
                <button type="submit" disabled={!isValid || loadingSend} className='step-button next-step'>

                    <span className="text">Prosseguir</span>
                    <span className='icon'> <Icon icon={loadingSend ? Loading : Arrow} size={18} /> </span>
                   
                </button>
            </div>
            {apiError !== "" && <div style={{width:"100%", display:"flex", justifyContent:"end", marginTop:"10px"}}> 
                <span style={{color:"red"}}> {apiError} </span>
            </div>
            }
        </form>

    )
}
